var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlkalineBatteries(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 51V38h10v2h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-1v-1h-2v6h1v1h-1v12h-1zm1 26v6h1v1h-1v6h-1V62h1v14h2v1zm31-39h10v2h-3v-1h-2v1h-2v-1h-3zM55 20h1v11h-1zm29 11h-1V20h1zm-46 69v8h-1V98h1v1h1v1zm1-81h2v1h2v1h-3v2h-1v-2zm35 13h-1v-1h-1v-1h1v-1h2v2h1v1zm-5 30h2v1h-1v6h-1zm0 21v-5h1v3h1v2zM40 30h1v1h-2v-5h1zm29 22h1v6h-1zm20-27v5h-1v-5zM74 43v-3h1v1h1v2zm-4 41v5h-1v-5zm8 21v-1h2v-2h1v3zm-9-65h1v4h-1v-1zm1 11h-1v-4h1v2zm-1 20h1v4h-1v-2zM44 98h-1v-4h1v1zm28 4v-1h-1v-1h2v1h1v1h-1zm-3-1h1v4h-1v-1zm7-80h-3v-1h3zm-26 2h1v3h-1zm23 3v3h-1v-3zm3 49v-1h3v1h-1zM39 92h1v3h-1zm37 5h-1v-3h1zm-28 11v-3h1v3zm25-88h-2v-1h2zm-31 4v-2h1v2zm1 7v1h-1v-2h1zm8 0h-1v-1h2v1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-2h1zm2 32h1v1h-2v-1zm-4 27h1v1h-2v-1zm1 1h2v1h-2zm32 0h2v1h-2zm-28 2h-2v-1h2zm31-1h1v1h-2v-1zm-8 4v-1h1v2h-1zM51 21v1h-1v-1zm20 0h1v1h-1zm1 2v-1h1v1zm3 0v-1h1v1zm12 0h1v1h-1zm-44 5v1h-1v-1zm33 0v1h-1v-1zm-34 2h-1v-1h1zm45 0h1v1h-1zm0 5v-1h1v1zm-45 6h-1v-1h1zm5 4h-1v-1h1zm25 0v1h-1v-1zm-1 1v1h-1v-1zm-1 5h1v1h-1zm6 4v1h-1v-1zm0 1h1v1h-1zm-35 3h1v1h-1zm34 2h-1v-1h1zm-4 9h-1v-1h1zm-28 4h-1v-1h1zm32 0h-1v-1h1zm-4 2h1v1h-1zm-1 1h1v1h-1zm1 7v-1h1v1zm-1 5h1v1h-1zm1 5h1v1h-1zm-2 4h1v1h-1zm1 2v-1h1v1zm-30 0v1h-1v-1zm6 4h1v1h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100v-1h2v1h1v-4h1v6h-1v-1h-2v-1zm-5-3v-6h1v5h1v1zm36-3h1v4h-1v1h-1v-1h-1v-1h2zM46 53v2h-1v-1h-2v-1zm28 3v1h-2v-3h1v2zm-28 6h-1v-1h-1v-1h1v-1h1zm-5 4h2v1h-3v-2h1zm31 1v-2h1v1h2v1zm-26 4v2h-1v-1h-2v-1zm32 2h-1v-1h-2v-1h3zm-5-29h-1v-3h1v1zm0 31h-1v-3h1zm4 11v-1h1v-1h1v2zm-32 3h-1v-1h2v2h-1zm-4-46v1h-2v-1h1zm33 2h-1v-1h2v1zm-30 0v1h-2v-1h1zm2 2h-2v-1h2zm31 0h-1v-1h2v1zm-38 1v-1h2v1h-1zm34-1h1v1h-2v-1zm-31 6h-1v-1h2v1zm34 0h1v1h-2v-1zm1 9v-2h1v2zm-38-1h2v1h-2zm34 1h2v1h-2zm-31 1h2v1h-2zm3 1h1v1h-2v-1zm32 0h1v1h-2v-1zm-34 3h2v1h-2zm32 1v-1h2v1h-1zm4 0v1h-2v-1h1zm-4 2v1h-2v-1h1zm-32 6h-2v-1h2zm32-1v1h-2v-1h1zm-30 2h1v1h-2v-1zm31 1v-1h2v1h-1zm-4 1v-1h2v1h-1zm-29 5h-2v-1h2zm31 0h-1v-1h2v1zm-31 1v-1h2v1h-1zm34-1v1h-2v-1h1zm-35 3h-2v-1h2zm30 0v-1h2v1h-1zm2 0h2v1h-2zm2 1h2v1h-2zm-3 3h-1v-1h2v1zm-30 0v1h-2v-1h1zm1 1h1v1h-2v-1zm32 0h1v1h-2v-1zm2 2h-1v-1h2v1zm-36 0v2h-1v-2zm34 5v1h-2v-1h1zM45 16v1h-1v-1zm32 0h1v1h-1zM42 45h-1v-1h1zm33 1v-1h1v1zm-1 2h1v1h-1zm-29 3v-1h1v1zm32-1h1v1h-1zm-37 1h1v1h-1zm34 2v-1h1v1zm-35 1h1v1h-1zm39 0v1h-1v-1zm-38 2v-1h1v1zm2 1h-1v-1h1zm1 1h-1v-1h1zm32-1v1h-1v-1zm1 1v1h-1v-1zm-33 2v-1h1v1zm34-1v1h-1v-1zm-4 2v1h-1v-1zm-32 1h1v1h-1zm35 2h-1v-1h1zm-37 3h1v1h-1zm6 2v-1h1v1zm-4 0v1h-1v-1zm7 0v1h-1v-1zm25 0v1h-1v-1zm7 0v1h-1v-1zm-38 2h-1v-1h1zm7 2v1h-1v-1zm31 1v-1h1v1zm-39 0v1h-1v-1zm3 2v1h-1v-1zm31 1v-1h1v1zm-35 2v-1h1v1zm34 1v-1h1v1zm-29 1h1v1h-1zm33 0v1h-1v-1zm-37 2h-1v-1h1zm38-1v1h-1v-1zm-33 3v1h-1v-1zm-3 2v1h-1v-1zm36 2v1h-1v-1zm-39 1h1v1h-1zm35 1v1h-1v-1zm-29 3h-1v-1h1zm24 3v-1h1v1zm-31 1v-1h1v1zm1 0h1v1h-1zm37 2v1h-1v-1zm0 2v-1h1v1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102v1h2v1h1v1h1v2h2v1H38v-8h1v1h1v1zm28 6v-2h-1v-1h1v-4h2v1h2v1h2v1h2v4zm17-78v-6h1v-1h-1v-1h1v-3h1v6h-1v5zM69 75h2v1h-1v2h-1zm2-54v-1h2v2h-1v-1zm5 20h-1v-1h-1v-1h2zm-7 6v-3h1v3zm0 36h2v2h-1v-1h-1zM50 29v-1h1v2h-1zm-9 2v-1h1v2h-1zm34 5h-1v-1h2v1zm-31 4v1h-2v-1h1zm25 31v-2h1v2zm2 16v2h-1v-2zm-2 12h1v2h-1v-1zm19-82h1v1h-1zm-44 3v1h-1v-1zm6 0h1v1h-1zm26 1v1h-1v-1zm-26 1h1v1h-1zm22 5v1h-1v-1zm-32 3v-1h1v1zm2 0v-1h1v1zm31 0h-1v-1h1zm0 1v1h-1v-1zm-21 3v1h-1v-1zm-11 5h1v1h-1zm29 1h-1v-1h1zm0 1h1v1h-1zm1 10h-1v-1h1zm-32 0v1h-1v-1zm30 0h1v1h-1zm1 7v-1h1v1zm-27 3h-1v-1h1zm28 12h-1v-1h1zM38 83v-1h1v1zm31 7v-1h1v1zm3 3v1h-1v-1zm9 14v1h-1v-1z",
    fill: "#010101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63h1v10h-1zm1-13h-1v-8h1v2zm-1 4v-3h1v3zm0 1h1v3h-1zm1-16v2h-1v-2zm-1 37v-2h1v2zm1 2v1h-1v-2h1zm-1 7h1v2h-1v-1zm1 14v2h-1v-2zm29-78h1v1h-1zm-27 1h1v1h-1zm8 0h1v1h-1zm32 13h1v1h-1zm-34 3h-1v-1h1zm31 0v-1h1v1zM42 54v1h-1v-1zm-6 6h1v1h-1zm0 2h-1v-1h1zm3 11v1h-1v-1zm1 3h1v1h-1zm-7 3v-1h1v1zm2 2v-1h1v1zm39-1v1h-1v-1zm-38 9v1h-1v-1zm33 1v1h-1v-1zm-35 14h-1v-1h1zm1 1v-1h1v1zm-1 1h-1v-1h1z",
    fill: "#3d3d3d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 72h1v5h-1zm0 9h1v4h-1v-1zm3 0v4h-1v-4zm-3-39v-3h1v3zm1 13h-1v-3h1v1zm-1 48v-3h1v3zm3 1h-1v-3h1zm-2-35v1h-1v-2h1zm1 19v-1h1v2h-1zm-2 1v-1h1v2h-1zm32-66h1v1h-1zm-22 9v1h-1v-1zm-7 10h-1v-1h1zm-2 5v1h-1v-1zm2 4h-1v-1h1zm-1 3h1v1h-1zm-2 7v-1h1v1zm2 2v-1h1v1zm-1 1h-1v-1h1zm0 2h-1v-1h1zm1 8v-1h1v1zm0 2h1v1h-1zm-2 3h1v1h-1zm3 1h-1v-1h1zm42 12h-1v-1h1zm-44 4h-1v-1h1zm2 3h-1v-1h1zm34-1h1v1h-1zm-36 6v1h-1v-1z",
    fill: "#3e3e3e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69h1v10h-1zm1 21h-1v-9h1zm0-37v1h-1v-4h1zm0 15h-1v-4h1v2zm0-7h-1v-3h1v1zm-1 36h1v3h-1zm0-58v-1h1v2h-1zm0 8h1v2h-1v-1zm0 10v-2h1v2zm1 38v1h-1v-2h1zm8-61h-1v-1h1zm34 3v1h-1v-1zm-42 4v1h-1v-1zm-1 21h1v1h-1zm8 15v1h-1v-1zm32 5h-1v-1h1zM34 92v-1h1v1z",
    fill: "#595959"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 24h1v6h-1zM34 60h-1v-5h1v1zm0-9v1h-1v-4h1zm0 45v4h-1v-4zm-1-8v-3h1v3zm0-27h1v2h-1v-1zm0 5h1v2h-1v-1zm0 5v-1h1v2h-1zm1 21h-1v-2h1v1zm-1 1h1v2h-1v-1zm14-72v1h-1v-1zm18 2v-1h1v1zm5 15v-1h1v1zm3-1v1h-1v-1zm-40 2v-1h1v1zm1 3v1h-1v-1zm0 5h-1v-1h1zm2 11h1v1h-1zm1 4v-1h1v1zm-3 2v1h-1v-1zm44 10v-1h1v1zm-44 3v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#3f3f3f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v12h-1zm0 24h1v5h-1v-1zm1 9v4h-1v-4zm-1 9h1v4h-1v-1zm0-28h1v3h-1v-1zm1 33v2h-1v-2zm-1 17v-1h1v2h-1zm18-78v-1h1v1zm0 5v-1h1v1zm28-1h1v1h-1zm-10 7h-1v-1h1zM36 70h1v1h-1zm35 2h-1v-1h1zm-34 7h-1v-1h1zm39 19v-1h1v1zm-40 1h1v1h-1z",
    fill: "#0d0d0d"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v4h-1v-2zm1-4v1h-1v-2h1zM37 52v1h-1v-2h1zm0 17v1h-1v-2h1zm-1 8v-1h1v2h-1zm0 3v-1h1v2h-1zm1 21v1h-1v-2h1zm-1 4v-1h1v2h-1zm2-87v1h-1v-1zm37 2h-1v-1h1zm7 1h1v1h-1zm-28 2h1v1h-1zm-16 4h1v1h-1zm46 4v-1h1v1zm-42 3v1h-1v-1zm42 1h-1v-1h1zm-40 1h-1v-1h1zm-1 7v-1h1v1zm-7 13h1v1h-1zm8 1h-1v-1h1zm-3 3h1v1h-1zm-5 2h1v1h-1zm1 9v1h-1v-1zm0 15h-1v-1h1zm-1 3v-1h1v1z",
    fill: "#0c0c0c"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v5h-1zm0 9h1v5h-1v-1zm1 24h-1v-5h1v1zm0-11v2h-1v-2zm0-75h1v1h-1zm7 3v1h-1v-1zm7 6v1h-1v-1zm-32 3v1h-1v-1zm31 1v-1h1v1zm-6 1h1v1h-1zm-8 12v-1h1v1zm0 2v-1h1v1zm0 22v-1h1v1zm1 8v1h-1v-1zm7 8h1v1h-1zm-8 4h1v1h-1zm-24 5h1v1h-1zm25 5h-1v-1h1zm10-1v1h-1v-1z",
    fill: "#565656"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67 68h-1v-6h1zm-1-7v-5h1v5zm1 28h-1v-3h1v1zM48 31v-2h1v2zm19 11v2h-1v-2zm0 27v2h-1v-2zm15-41h-1v-1h1zm-34 4h-1v-1h1zm-4 6v-1h1v1zm22-1h1v1h-1zm1 8v1h-1v-1zm-1 2h1v1h-1zm-23 2h1v1h-1zm23 3h1v1h-1zm1 25h-1v-1h1zm-1 2v-1h1v1zm-24 22h-1v-1h1zm25 4v1h-1v-1z",
    fill: "#555"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v7h-1v-7zM55 68h1v7h-1v-2zm33 10v-1h1v5h-1zm0 6v-1h1v2h-1zm1 5h-1v-2h1v1zm-1-46h-1v-1h1zm-46 0v1h-1v-1zm46 10h-1v-1h1zM55 67v-1h1v1zm-15 6v-1h1v1zm1 14v1h-1v-1z",
    fill: "#d3d3d3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29h-1v-8h1zm33-4h1v3h-1zM69 52v2h-1v-2zm-1 12v-2h1v2zM33 20h-1v-1h1zm53 1h1v1h-1zm-48 2h-1v-1h1zm12 0h-1v-1h1zm24 1h1v1h-1zm12 5h1v1h-1zm-15 2v1h-1v-1zm18 2v1h-1v-1zM68 56h1v1h-1zm0 11h1v1h-1zM39 88v1h-1v-1z",
    fill: "#1f1f1f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1V20h1zM65 64h1v7h-1v-4zm0-6h1v5h-1v-1zm8-33h-1v-1h1zm-40 5v1h-1v-1zm17 1h-1v-1h1zm-8 63v-1h1v1z",
    fill: "#2a2a2a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68 68h1v5h-1v-1zm1-1h-1v-3h1zm18-44v1h-1v-2h1zm-43-4h1v1h-1zm42 2v-1h1v1zm-11 4v1h-1v-1zm-23 4h1v1h-1zm-8 5v1h-1v-1zm25 0h1v1h-1zm14 0v1h-1v-1zm2 1v-1h1v1zm-17 4v-1h1v1zm0 21v-1h1v1zm1 15h-1v-1h1zm0 2h-1v-1h1zm-1 5v-1h1v1z",
    fill: "#1e1e1e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v5h-1v-1zm1 38v1h-1v-2h1zm0 12v2h-1v-2zm0-72h1v1h-1zm39 5h-1v-1h1zm13 7h-1v-1h1zm-33 1h1v1h-1zm21 3h1v1h-1zm-41 1h1v1h-1zm1 18h-1v-1h1zm0 3h-1v-1h1zm0 5v1h-1v-1zm3 5v-1h1v1zm-3 0v1h-1v-1zm5 2v1h-1v-1zm-5 20v1h-1v-1zm-1 7v-1h1v1z",
    fill: "#5a5a5a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-2h1v1zm-13 7h1v2h-1v-1zm-5 17v-2h1v2zM55 18v-1h1v1zm33 0h1v1h-1zm-49 1v1h-1v-1zm4 6h-1v-1h1zm29 0h1v1h-1zm-22 2v-1h1v1zm22 3v1h-1v-1zm2 5v1h-1v-1zm-30 4v1h-1v-1zm-4 7h-1v-1h1zm6 30h-1v-1h1zm24 1v-1h1v1zm1 15h1v1h-1zm-1 8h1v1h-1zm7 9v-1h1v1z",
    fill: "#020202"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88 71h1v5h-1zM56 56v1h-1v-4h1zm-1 7v-3h1v3zm33-24v2h-1v-2zM71 49h1v1h-1zm17 15v-1h1v1zm0 5v-1h1v1zm-45 4v-1h1v1zm32 3v-1h1v1zm-3 10v1h-1v-1zm5 16h-1v-1h1z",
    fill: "#d1d1d1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v1h-1v-2h1v-1h1zm18 23h-1v-4h1v2zm-1 4v-3h1v3zm1-17v1h-1v-2h1zM36 18v-1h1v1zm42 8v1h-1v-1zm3 8h1v1h-1zm-15 8v-1h1v1zm-24 1h1v1h-1zm24 19v-1h1v1zm9 28h1v1h-1z",
    fill: "#545454"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v8h-1v-2zm0-22v-1h1v2h-1zM34 20v1h-1v-1zm47 6v1h-1v-1zM43 48h1v1h-1zm33 15v-1h1v1zm-1 3v-1h1v1zm-7 6h-1v-1h1zm11 1v-1h1v1zm-11 1v1h-1v-1zm0 5v1h-1v-1zm5 13h1v1h-1z",
    fill: "#4d4d4d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v-1h1v5h-1zm1-2h-1v-4h1v1zM38 21h-1v-1h1zm11-1h1v1h-1zm20 2v-1h1v1zm-28 1v1h-1v-1zm-3 3v1h-1v-1zm37 8h1v1h-1zM43 56h-1v-1h1zm26 5v1h-1v-1zM38 71v-1h1v1zm30 2h1v1h-1zm0 3v-1h1v1z",
    fill: "#1d1d1d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v6h-1v-6zm0-2h-1v-3h1v1zm15-75v-1h1v1zm-45 0h1v1h-1zm8 0h1v1h-1zm34 1h-1v-1h1zm-42 2v-1h1v1zm39 3v1h-1v-1zm3 5h-1v-1h1zm-45 1v1h-1v-1zm8 5h-1v-1h1zm-2 53h1v1h-1zm26 15v-1h1v1z",
    fill: "#2f2f2f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48h1v4h-1v-1zm12-19h1v2h-1v-1zM67 56v-2h1v2zm1 7v2h-1v-2zm14-40h-1v-1h1zm-49 8v-1h1v1zm6 10h-1v-1h1zm28 2h1v1h-1zm8 5v-1h1v1zm-8 10v-1h1v1zm1 4h-1v-1h1zm-23 1h-1v-1h1zm22 7v-1h1v1zM43 81v-1h1v1z",
    fill: "#4f4f4f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-6h1v6zm0 1h1v6h-1v-1zm0-13h1v4h-1v-2zM51 37h1v1h-1zm27 10v1h-1v-1zm-5 12h-1v-1h1zm14 6h1v1h-1z",
    fill: "#d8d8d8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v-1h1v4h-1zm1-6h-1v-3h1v1zm-1 1h1v3h-1zm0 12h1v3h-1v-1zM43 49h-1v-1h1zm11 13v-1h1v1zm0 3v-1h1v1zm-14 2h-1v-1h1zm-1 15v-1h1v1zm15 0h1v1h-1zm1 12h-1v-1h1z",
    fill: "#e3e3e3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69 28h-1v-3h1v1zm-2 66h1v3h-1zm2-71h-1v-2h1v1zm-34-6h1v1h-1zm11 6h1v1h-1zm23 1h1v1h-1zm-1 6v-1h1v1zm13 5h1v1h-1zm-6 2h-1v-1h1zm-37 5h1v1h-1zm2 17h1v1h-1zm32 0v1h-1v-1zm-34 5h1v1h-1zm29 27h1v1h-1z",
    fill: "#484848"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v1h-1v-2h1zm0 5h-1v-2h1v1zm-2-38h-1v-1h1zm10 2h-1v-1h1zm-24 0v1h-1v-1zm-12 5h-1v-1h1zm46 0h-1v-1h1zm-42 3h-1v-1h1zm41 0h1v1h-1zm-17 3h1v1h-1zm-1 17h1v1h-1zm7 6v1h-1v-1zm-6 4h-1v-1h1zm5 2v1h-1v-1zM38 88v-1h1v1zm31 2h-1v-1h1zm-24 12v1h-1v-1z",
    fill: "#202020"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v6h-1v-6zm34-82h-1v-1h1zm11 12v-1h1v1zm-14 3v1h-1v-1zm-30 2h-1v-1h1zm37 2v-1h1v1zm-39 4v-1h1v1zm42 3h1v1h-1zm-42 6v-1h1v1zm40 6v-1h1v1zm-39 5v1h-1v-1zm38 2v1h-1v-1zm1 15v-1h1v1zm-31 8h-1v-1h1z",
    fill: "#585858"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-4h1v2zm-1 10v-4h1v4zm0-27h1v2h-1v-1zm1 22h-1v-2h1v1zM35 20v-1h1v1zm2 16h-1v-1h1zm30 2h1v1h-1zm0 23v-1h1v1zm0 2v-1h1v1zm0 8v-1h1v1zm0 10v-1h1v1z",
    fill: "#4e4e4e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h1v3h-1v-1zM53 21v-1h1v2h-1zm1 6v2h-1v-2zm11 50v-2h1v2zm0 3v-2h1v2zm21-60h-1v-1h1zm-37 3h1v1h-1zm5 1v1h-1v-1zm-18 1h1v1h-1zm38 2v-1h1v1zm0 1v1h-1v-1zm-38 3v-1h1v1zm3 64h1v1h-1z",
    fill: "#2c2c2c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M67 27v-5h1v5zm-32 2v1h-1v-2h1zm33-13h1v1h-1zm-33 5v1h-1v-1zm32 8v-1h1v1zm13 5h1v1h-1zm-6 12h1v1h-1zm-1 4h1v1h-1zm-36 8h1v1h-1zm9 12h1v1h-1zm-4 7h1v1h-1zm-5 13v1h-1v-1zm38 3h1v1h-1z",
    fill: "#6b6b6b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23h1v2h-1v-1zm-52-6h1v1h-1zm33 1v-1h1v1zm-20 3h-1v-1h1zm6 11h-1v-1h1zm26 0h-1v-1h1zm5-1h1v1h-1zm-40 4v-1h1v1zm43-1v1h-1v-1zm-46 1h1v1h-1zm5 7h-1v-1h1zm26 7v-1h1v1zm-34 8h1v1h-1zm8 17h-1v-1h1zm29 18v1h-1v-1zm3 3h1v1h-1zm-7 12v1h-1v-1z",
    fill: "#101010"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28h-2v-1h2zm-6 7h-1v-1h2v1zm30 69h1v2h-1v-1zm8-84h-1v-1h1zm-33 5v1h-1v-1zm-2 2h-1v-1h1zm4-1v1h-1v-1zm25 1h-1v-1h1zm-33 1v-1h1v1zm45 0v-1h1v1zm-12 1v-1h1v1zm-1 0h1v1h-1zm2 6v-1h1v1zM39 82h-1v-1h1zm29 17v-1h1v1z",
    fill: "#1a1a1a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77h1v8h-1v-1zm33-21h-1v-3h1zm-48 5h-1v-1h1zm11 10v-1h1v1zm4 16v-1h1v1zm33 2h1v1h-1zm-45 4h-1v-1h1zm13 0h-1v-1h1zm33 1h-1v-1h1z",
    fill: "#d5d5d5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20h1v10h-1zm-10 0v-1h1v1zm9 0v-1h1v1zm5 14v1h-1v-1zm-12 1v1h-1v-1zm27 20v-1h1v1zm1 12h-1v-1h1zM38 84h1v1h-1z",
    fill: "#040404"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h2v1h-2zm16 24h1v2h-1v-1zM51 20v-1h1v1zm26 1h-1v-1h1zm-37 1v-1h1v1zm34 0v-1h1v1zm-30 6v1h-1v-1zm27 4v-1h1v1zm-29 4h-1v-1h1zm29 18h-1v-1h1zm8 18v-1h1v1zm-9 1h1v1h-1zm6 24v1h-1v-1zm-39 11h-1v-1h1z",
    fill: "#060606"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v1h-1v-4h1zm-1-13v-1h1v2h-1zm1 17v1h-1v-2h1zM35 19v1h-1v-1zm43 6v-1h1v1zm3 6h-1v-1h1zm-39 3h-1v-1h1zm36 0v1h-1v-1zm-10 4h-1v-1h1zm8 49v-1h1v1zM66 99h1v1h-1z",
    fill: "#575757"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v-1h1v4h-1zm-4-12v3h-1v-3zm45-14v2h-1v-2zm-11-9v-1h1v1zM42 32v1h-1v-1zm0 37v-1h1v1zm32 4v-1h1v1zM33 93v-1h1v1zm38 3v-1h1v1zm2 5v-1h1v1z",
    fill: "#404040"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-5h1v2zm32 11h1v4h-1v-1zm-33-8v-2h1v2zm48-11v1h-1v-1zm-30 9v1h-1v-1zm-6 7h1v1h-1zm-6 38v-1h1v1zm0 18v-1h1v1z",
    fill: "#262626"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-3h1zM56 76v1h-1v-2h1zm32 10v-1h1v2h-1zm-32 3h-1v-2h1v1zM46 26h1v1h-1zm42 26h-1v-1h1zm-47 3h1v1h-1zm34 3v-1h1v1zm-1 0h1v1h-1zM43 77h1v1h-1zm46 6h-1v-1h1z",
    fill: "#d4d4d4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v4h-1v-4zm33-27h-1v-1h1zm-48 8h1v1h-1zm14 7v-1h1v1zm-13 1h-1v-1h1zm37 1v-1h1v1zm-24 5h1v1h-1zm0 2h-1v-1h1zm26 3v1h-1v-1zm6 11h1v1h-1zm-36 1v1h-1v-1zm-9 1h1v1h-1zm0 16v1h-1v-1z",
    fill: "#f3f3f3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v-1h1v5h-1zm-36-4h1v3h-1zm37 12h-1v-3h1zm-1-29h1v1h-1zM71 49v-1h1v1zm-19 1v1h-1v-1zm26 12h1v1h-1zM55 90v-1h1v1z",
    fill: "#d6d6d6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v2h-1v-1zm0 38v-1h1v2h-1zm0-45v-1h1v1zm1 2h-1v-1h1zm-2 1v1h-1v-1zm1 3v-1h1v1zm-11 2h-1v-1h1zm-33 1v-1h1v1zm43 2v1h-1v-1zM39 72h1v1h-1zm47 6v-1h1v1zm0 2h1v1h-1zm-10 3v1h-1v-1zm-7 12h1v1h-1z",
    fill: "#eaeaea"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71v4h-1v-4zM54 22v2h-1v-2zm-1 3h1v2h-1v-1zm1-6v1h-1v-1zm-8 1h1v1h-1zm-7 6v1h-1v-1zm14 4v-1h1v1zm-16 4v1h-1v-1zm33 3v1h-1v-1zm-4 41h-1v-1h1z",
    fill: "#2b2b2b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1zm-16 3h1v1h-1zm-33 2h1v1h-1zm1 6v1h-1v-1zm4 0v1h-1v-1zm28 4h1v1h-1zm-30 7h-1v-1h1zm34 9h1v1h-1zm-6 2v-1h1v1zm3 6h1v1h-1zm-2 7h-1v-1h1zm0 8v1h-1v-1zm-33 4v-1h1v1zm32 2h1v1h-1zm0 5h1v1h-1z",
    fill: "#050505"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v5h-1zM54 17v-1h1v1zM37 38v-1h1v1zm5 0v-1h1v1zm30 15h-1v-1h1zm-6 11h-1v-1h1zm8 5v-1h1v1zM42 89h-1v-1h1zm-3 10h1v1h-1zm-4 9v-1h1v1z",
    fill: "#292929"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36 26h1v4h-1v-1zm30 62h-1v-3h1zM36 20h1v1h-1zm14 11v1h-1v-1zm-6 20v1h-1v-1zm29 18v-1h1v1zm-30 9h1v1h-1zm23 11v1h-1v-1zm-1 3h1v1h-1z",
    fill: "#2e2e2e"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v-3h1v3zm0-8v-1h1v2h-1zm33 13v-2h1v2zm-1-29v-1h1v1zM38 60v1h-1v-1zm34 4h1v1h-1zm-16 3v1h-1v-1zm32 9h1v1h-1zm-10 2v1h-1v-1zm-37 1v1h-1v-1z",
    fill: "#d2d2d2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h-1v-4h1v2zm-11-8h-1v-1h1zm28 10h1v1h-1zm-34 3h-1v-1h1zm16 4v-1h1v1zm-11 0h1v1h-1zm35 2h-1v-1h1zm0 1v1h-1v-1zm-5 14v1h-1v-1zm2 0v1h-1v-1zM40 98v1h-1v-1z",
    fill: "#e1e1e1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v3h-1v-1h-1v-1h1zm32-44v-1h2v1h-1zm-31 0h-1v-1h1zm-3 12h1v1h-1zm0 5v-1h1v1zm3 3v-1h1v1zm0 5v-1h1v1zm1 11v-1h1v1zm31 11h-1v-1h1zm2 2h-1v-1h1z",
    fill: "#fefefe"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-8h1zm-37-3v-1h1v2h-1zm37-11v1h-1v-1zm0 19v1h-1v-1zm-46 7v-1h1v1zm45 0h1v1h-1z",
    fill: "#d7d7d7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v2h-1v-1zm-3 5h2v1h-2zm-6-18v1h-1v-1zm5 7h-1v-1h1zm-2 3h-1v-1h1zm7 1v1h-1v-1zM42 69h-1v-1h1zm6 2v1h-1v-1zm27 4v-1h1v1zm-36 9v-1h1v1zm38 19h-1v-1h1z",
    fill: "#141414"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-2h1zm21-73h-1v-1h1zm-8 2h1v1h-1zm-43 3v-1h1v1zm39 5v-1h1v1zm-5 7v1h-1v-1zm4 2h1v1h-1zm-2 8h1v1h-1zm-7 35h1v1h-1zm1 5h-1v-1h1zm0 3v1h-1v-1zm-1 19v-1h1v1z",
    fill: "#2d2d2d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48v-9h1v9zm2-27h-1v-1h1zm5 2h-1v-1h1zm-7 27v-1h1v1zm2 8h1v1h-1z",
    fill: "#212121"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M84 27h1v3h-1v-1zm1-6v2h-1v-2zm-8 23h-2v-1h2zM41 21h1v1h-1zm43 5v-1h1v1zm-8 15v-1h1v1zM44 62h-1v-1h1zm27 6h-1v-1h1zm-30 4h1v1h-1z",
    fill: "#111"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88 41v-1h1v5h-1zm-33-4h1v2h-1v-1zm26-13h-1v-1h1zm7 13v-1h1v1zM45 87v1h-1v-1zm27 9h1v1h-1zm0 2v1h-1v-1zm-30 2h1v1h-1z",
    fill: "#cacaca"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56 51h-1v-4h1v1zm31-13v-1h1v2h-1zm2 24v1h-1v-2h1zM44 50h1v1h-1zm11 3v-1h1v1zm17 11v1h-1v-1zm-1 5v-1h1v1zm-29 0v1h-1v-1z",
    fill: "#cfcfcf"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v3h-1v-3zm0 19h-1v-3h1zM75 53v-1h1v1zm12-1v1h-1v-1zM73 62v1h-1v-1zm3 5h-1v-1h1zm-3 12v1h-1v-1zm-33 1v1h-1v-1zm2 2v-1h1v1z",
    fill: "#ebebeb"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-4h1v1zm-2-80h1v1h-1zm33 2v1h-1v-1zm4 4v1h-1v-1zm2 28v-1h1v1zm-31 5v-1h1v1zm34 1v-1h1v1zm-38 3v-1h1v1zm0 5v-1h1v1z",
    fill: "#353535"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1zm-48 7h-1v-1h1zm12 1h-1v-1h1zm-3 5h-1v-1h1zm22 0v1h-1v-1zm13 0v1h-1v-1zm-29 1v1h-1v-1zm-18 6h1v1h-1zm3 17v-1h1v1zm4 8v-1h1v1zm-3 9v1h-1v-1zm36 7h1v1h-1z",
    fill: "#464646"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1zm41 0v-1h1v1zM45 30v-1h1v1zm20 0h1v1h-1zm-20 5h-1v-1h1zm39 0h1v1h-1zM43 50h1v1h-1zm-4 25h-1v-1h1zm-1 6v-1h1v1zm6 2h-1v-1h1zm25 9h-1v-1h1zm-34 6v-1h1v1z",
    fill: "#3b3b3b"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-2h1zm33-3v1h-1v-1zm4 1v1h-1v-1zM53 31v-1h1v1zm33-1v1h-1v-1zm-30 4h-1v-1h1zm-18 2v-1h1v1zm32 0v-1h1v1zm-33 1v1h-1v-1zm5 1h-1v-1h1zm-2 55v-1h1v1z",
    fill: "#252525"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1zm17 0v1h-1v-1zm2 2h1v1h-1zm-18 2h-1v-1h1zm-14 5v1h-1v-1zm41 0h1v1h-1zm1 4v-1h1v1zm-13 9v-1h1v1zm4-1v1h-1v-1zm-3 40h-1v-1h1zm0 6v1h-1v-1zm-34 20v1h-1v-1z",
    fill: "#0b0b0b"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69 88v1h-1v-2h1zm17-69h1v1h-1zm-45 4h-1v-1h1zm-1 2h1v1h-1zm29 2h1v1h-1zM38 53v-1h1v1zm30 7h1v1h-1zm8 35v-1h1v1zm-40 3v-1h1v1zm33-1v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#1c1c1c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25h1v3h-1zm1-2v1h-1v-2h1zm44 5h-1v-1h1zm-13 3h-1v-1h1zm2 4v1h-1v-1zm7 25v1h-1v-1zm-2 5h-1v-1h1zm2 11v-1h1v1zM41 92h1v1h-1z",
    fill: "#5f5f5f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56 44v3h-1v-3zm32 14h1v3h-1zm-7-35h-1v-1h1zM56 52h-1v-1h1zm32 4h1v1h-1zm-47 7h1v1h-1zm34 2v-1h1v1zm-3 2h1v1h-1z",
    fill: "#cecece"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52v1h-1v-5h1zm0-8v1h-1v-2h1zM41 28h1v1h-1zm9 1v1h-1v-1zm16 17v1h-1v-1zM44 57v-1h1v1zm-6 32h1v1h-1z",
    fill: "#282828"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43h-1v-4h1v2zm32 5v-1h1v4h-1zm-13-1v1h-1v-1zm1 23v1h-1v-1zm-37 1h1v1h-1zm32 9h1v1h-1z",
    fill: "#ccc"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-2h1v2zm-1 26v-1h1v2h-1zM56 19v1h-1v-1zm-5 8v1h-1v-1zm38 4h-1v-1h1zm-48 1h-1v-1h1zm2 23h1v1h-1zm28 24h-1v-1h1zm-30 22h-1v-1h1z",
    fill: "#030303"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M46 30h1v2h-1v-1zm23-6h-1v-1h1zm-1 4h1v1h-1zm18 4h-1v-1h1zm-12 9v1h-1v-1zm-3 6v-1h1v1zm3 25v1h-1v-1zm-36 7h1v1h-1zm3 5v1h-1v-1zm27 22v1h-1v-1z",
    fill: "#474747"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v3h-1v-3zM55 32v1h-1v-1zm30 4v1h-1v-1zm1 3v-1h1v1zm-14 6v-1h1v1zM39 66v-1h1v1zm36 1v1h-1v-1zm-2 2h1v1h-1zm14 22h-1v-1h1z",
    fill: "#e8e8e8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v-1h1v4h-1zm1 4v4h-1v-4zM33 34h1v1h-1zm44 7v1h-1v-1zM67 56h1v1h-1z",
    fill: "#505050"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M55 68v1h-1v-4h1zm-1-31v-1h1v1zM42 50v-1h1v1zm30 0h1v1h-1zM55 72v1h-1v-1zm-1 5v-1h1v1zm0 8v-1h1v1zM41 96v1h-1v-1z",
    fill: "#e4e4e4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39h1v3h-1zm1-2v1h-1v-1zM75 57h-1v-1h1zm0 3v-1h1v1zm-31 4v-1h1v1zm40 1v-1h1v1zm2 20v-1h1v1zm-44 2v1h-1v-1zm28 9v1h-1v-1z",
    fill: "#e9e9e9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-5h1v2zm26-24h1v1h-1zM39 69h1v1h-1zm39 3v-1h1v1zm6 1h-1v-1h1zm-28 4v-1h1v1zm14 15h1v1h-1z",
    fill: "#c5c5c5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67 106v-2h1v2zm0-90h1v1h-1zm0 4h-1v-1h1zm-25 6h1v1h-1zm37 3v-1h1v1zm-47 7h1v1h-1zm12 29v1h-1v-1zm-1 15v-1h1v1zm24 18v-1h1v1z",
    fill: "#4b4b4b"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M83 24v1h-1v-2h1zm4-6v-1h1v1zm-1 0h1v1h-1zm-48 4v-1h1v1zm6 8h-1v-1h1zm11 5v-1h1v1zm16 30h-1v-1h1zm-1 5h1v1h-1zm5 31v1h-1v-1z",
    fill: "#080808"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1zm-8 13h-1v-1h1zm42-1v1h-1v-1zm-14 3h1v1h-1zm-31 3v1h-1v-1zm2 1v1h-1v-1zm40 19h-1v-1h1zm-1 3h-1v-1h1zM43 91v-1h1v1zm-7 15h-1v-1h1z",
    fill: "#3c3c3c"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20h1v1h-1zm5 2v-1h1v1zm0 9v-1h1v1zm-2 5h-1v-1h1zm30 3v1h-1v-1zm-1 10h1v1h-1zm0 14h1v1h-1zm1 5v1h-1v-1zM43 90h-1v-1h1zm34 1h-1v-1h1z",
    fill: "#090909"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1zm-38 3h-1v-1h1zm31 3v1h-1v-1zm-33 3h-1v-1h1zm33 1h-1v-1h1zm1 3h1v1h-1zM38 44h1v1h-1zm7 38v1h-1v-1zm26 2h1v1h-1zm0 15h1v1h-1z",
    fill: "#181818"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-2h1v1zm-1-8v-1h1v1zm15 5v1h-1v-1zm32 0h1v1h-1zM41 65v-1h1v1zm2 4v1h-1v-1zm33 1v-1h1v1zm-32 4v-1h1v1zm22 32h1v1h-1z",
    fill: "#525252"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v2h-1v-2zm0-6h-1v-1h1zm0 3h-1v-1h1zm37 0h1v1h-1zm-32 1h1v1h-1zm7 1h-1v-1h1zm1 8h-1v-1h1zM38 48h1v1h-1zm3 41h1v1h-1z",
    fill: "#5e5e5e"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v6h-1v-1zm15 8v1h-1v-1zm19 10v1h-1v-1zM42 59h-1v-1h1zm-7 48h-1v-1h1z",
    fill: "#535353"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h-1v-6h1zm11-73h1v1h-1zM39 48h-1v-1h1zm38 18h1v1h-1zM67 90v-1h1v1z",
    fill: "#4c4c4c"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82v-1h1v4h-1zm0-49h-1v-1h1zm22 0v1h-1v-1zm10 6v-1h1v1zm-5 32v-1h1v1zm-4 1v1h-1v-1zm-7 2v1h-1v-1z",
    fill: "#c8c8c8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v1h-1v-2h1zm32-35h1v1h-1zM74 49h1v1h-1zm-22 9h1v1h-1zm1 4v1h-1v-1zm33 10v1h-1v-1zm0 6h-1v-1h1zM42 99v-1h1v1zm32 0v1h-1v-1z",
    fill: "#f2f2f2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47h-1v-3h1zm0-7v2h-1v-2zM41 57h1v1h-1zm1 17v1h-1v-1zm-3 14h1v1h-1zm0 2h1v1h-1zm6 12h-1v-1h1z",
    fill: "#dedede"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28h1v3h-1zm49-12h1v1h-1zm-18 2h1v1h-1zm7 5v1h-1v-1zM39 35v-1h1v1zm-1 12v-1h1v1zm-2 14h1v1h-1z",
    fill: "#0f0f0f"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h2v1h-1zm10-16h1v1h-1zm27 7v1h-1v-1zm9 8v1h-1v-1zm3 0h1v1h-1zm6 4h-1v-1h1zM44 86h-1v-1h1zm-3 8h-1v-1h1z",
    fill: "#adadad"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-2h1zm0-77h-1v-1h1zm11 15h1v1h-1zm-38 6v1h-1v-1zm-1 25v-1h1v1zm34 12h-1v-1h1zm3 16h-1v-1h1zm-10 10h1v1h-1z",
    fill: "#303030"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M69 104h-1v-3h1v1zM38 21v1h-1v-1zm2 6h1v1h-1zm30 1v1h-1v-1zm-38 9h1v1h-1zm12 15v-1h1v1zm25 47v1h-1v-1z",
    fill: "#1b1b1b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22h1v6h-1zm37 4h-1v-1h1zm-4 2v-1h1v1zm5 16v1h-1v-1z",
    fill: "#6c6c6c"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1zm-32 6v1h-1v-1zm32 1h1v1h-1zm-1 1h1v1h-1zm17 1v-1h1v1zm-47 0v1h-1v-1zm44 4h1v1h-1zm-43 4v1h-1v-1zm28 68v-1h1v1z",
    fill: "#191919"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1zm0 3h-1v-1h1zm-43 6h-1v-1h1zm44 0h-1v-1h1zm-4 1h-1v-1h1zm-33 2h1v1h-1zm26 0v1h-1v-1zm-30 9h-1v-1h1zm31 22v-1h1v1z",
    fill: "#9e9e9e"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1zM39 57h1v1h-1zm35 6h1v1h-1zm-32 7h1v1h-1zm2 2h1v1h-1zm-5 2h1v1h-1zm38 2v1h-1v-1zM40 86v1h-1v-1zm2 5h-1v-1h1z",
    fill: "#fdfdfd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64v2h-1v-2zm32-31h-1v-1h1zm-5 0h1v1h-1zM41 49h-1v-1h1zm30 13v-1h1v1zm-15 0h1v1h-1zm19 16v1h-1v-1zm-4 15v1h-1v-1z",
    fill: "#c2c2c2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-4h1v2zm-9-29h1v1h-1zm-2 8h1v1h-1zm-2 33h-1v-1h1zm36 2v1h-1v-1zm-6 4h-1v-1h1z",
    fill: "#f0f0f0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M54 58h1v3h-1zm-11-8v1h-1v-1zm12 12v1h-1v-1zm27 10v1h-1v-1zm-9 4h-1v-1h1zM40 88h-1v-1h1zm34-1v1h-1v-1z",
    fill: "#e2e2e2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1zm-6 3h1v1h-1zm2 8v-1h1v1zm-3 0v1h-1v-1zm31 6v1h-1v-1zm-6 36h1v1h-1zm1 15v-1h1v1zm-3 12h-1v-1h1z",
    fill: "#373737"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1zm1 5v1h-1v-1zm-25 8v1h-1v-1zm6 1v-1h1v1zm14 6v-1h1v1zm6 2v-1h1v1zm1 37v-1h1v1zm0 14v1h-1v-1z",
    fill: "#222"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1zm-9 5v1h-1v-1zm3 2h-1v-1h1zm9 5h1v1h-1zm-12 4h-1v-1h1zm-28 5v1h-1v-1zm-3 29v-1h1v1zm1 18h-1v-1h1z",
    fill: "#444"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1zm0 7h1v1h-1zm-34 5v-1h1v1zm53 1v1h-1v-1zM75 65h-1v-1h1zm-3 29h1v1h-1zm-36 2h1v1h-1zm34 2h-1v-1h1z",
    fill: "#6a6a6a"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1zm18 8h-1v-1h1zm-6 1h-1v-1h1zm-16 2h1v1h-1zm53 1v-1h1v1zm-47 1h-1v-1h1zm5 42v1h-1v-1zm-6 3h1v1h-1z",
    fill: "#8f8f8f"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M66 23h1v4h-1v-2zm1 6v1h-1v-2h1zm-26-5h1v1h-1zm2 50v1h-1v-1z",
    fill: "#626262"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1zm-14 7v-1h1v1zm31 4v1h-1v-1zm10 12v-1h1v1zm-35 6h-1v-1h1zm28 5v-1h1v1zm-29 2v-1h1v1zm36 9h1v1h-1z",
    fill: "#6d6d6d"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-2v-1h2zm26-6v1h-1v-1zm18 2h1v1h-1zm-10 9v1h-1v-1zm-36 4h-1v-1h1zm-2 3v1h-1v-1zm-1 12h1v1h-1z",
    fill: "#515151"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1zm38 16v1h-1v-1zm-4 6v1h-1v-1zm3 7v1h-1v-1zm-36 6h1v1h-1zm31 12v-1h1v1zm5 0v-1h1v1zm2 11h-1v-1h1z",
    fill: "#fafafa"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1zm1 14h1v1h-1zm34 3v-1h1v1zm-34 2v-1h1v1zm35 6h-1v-1h1zm-2 8h-1v-1h1zm3 16h-1v-1h1zm-2 7v-1h1v1z",
    fill: "#f7f7f7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v-1h1v2h-1zm-32-6h1v1h-1zm33 4h-1v-1h1zm-12 3h1v1h-1zm-1 4v-1h1v1zm-34 3h1v1h-1zm5 14h-1v-1h1z",
    fill: "#f4f4f4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18v-1h1v1zm9 5v-1h1v1zm31 36h-1v-1h1zm-4 3h-1v-1h1zm-31 4v1h-1v-1zm0 12v1h-1v-1zm-1 8v-1h1v1z",
    fill: "#313131"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1zm0 3h1v1h-1zm4 17v1h-1v-1zM40 53h-1v-1h1zm31 8v1h-1v-1zM44 89v1h-1v-1zm35 13h1v1h-1z",
    fill: "#454545"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1zm3 1v-1h1v1zm43 3h-1v-1h1zm-2 4h-1v-1h1zm1 2h-1v-1h1zm-40 6v1h-1v-1zm38 54v1h-1v-1z",
    fill: "#323232"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1zm9 3v-1h1v1zm25 4h1v1h-1zm12 0h1v1h-1zm-5 2v-1h1v1zM36 92h-1v-1h1zm0 4v1h-1v-1z",
    fill: "#343434"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1zm11 3h1v1h-1zM43 47h1v1h-1zm-7 12h-1v-1h1zm0 1v1h-1v-1zm32 34h1v1h-1zm-33 12h1v1h-1z",
    fill: "#383838"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20h-1v-1h1zm-45 7v1h-1v-1zm38 8h-1v-1h1zm-6 8v-1h1v1zm1 3h-1v-1h1zm0 2h-1v-1h1zm-28 2h1v1h-1z",
    fill: "#272727"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1zm-2 8v1h-1v-1zm-33 4h-1v-1h1zm23 6h-1v-1h1zM39 84h1v1h-1zm29 10v-1h1v1zm0 2v-1h1v1z",
    fill: "#393939"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v2h-1v-2zm5-8v1h-1v-1zm35 11h-1v-1h1zm-46 8h-1v-1h1zm1 9h1v1h-1zm28 10v-1h1v1z",
    fill: "#232323"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v2h-1zm12-72h1v1h-1zm-8 31v-1h1v1zm6 22h-1v-1h1zm-5 9h-1v-1h1zm-5 7h1v1h-1z",
    fill: "#494949"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1zm29 1h-1v-1h1zM67 36h1v1h-1zm6 9h1v1h-1zm-30 2v1h-1v-1zm30 39v-1h1v1zM41 99v1h-1v-1z",
    fill: "#a5a5a5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1zm39 10v1h-1v-1zm-13 7h1v1h-1zm-30 7h-1v-1h1zm2 23h1v1h-1zm28 9v-1h1v1zm4 20v-1h1v1z",
    fill: "#b2b2b2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v2h-1v-2zm-41-4h-1v-1h1zm38 7v1h-1v-1zm-43 2h1v1h-1zm41 3h1v1h-1zm-31 6h-1v-1h1z",
    fill: "#333"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-2h1v2zm-8-43h1v1h-1zm24 22v1h-1v-1zm0 7v1h-1v-1zM57 64h-1v-1h1zm14 31h-1v-1h1z",
    fill: "#c3c3c3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1zm-41 4h-1v-1h1zm47-1h1v1h-1zM39 70h-1v-1h1zm4-1h1v1h-1zm-4 7h-1v-1h1zm35 14v-1h1v1z",
    fill: "#0e0e0e"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1zm53 4v-1h1v1zM71 61h-1v-1h1zM47 73v-1h1v1zm27 2v-1h1v1zm1 7h1v1h-1zm-2 7h1v1h-1z",
    fill: "#828282"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1zm4-1h1v1h-1zm6 37h-1v-1h1zm34 1v-1h1v1zM41 84h1v1h-1zm33 4h1v1h-1zm-36 9v1h-1v-1z",
    fill: "#8e8e8e"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1zm34 14v1h-1v-1zm3 16h-1v-1h1zm-34 3h-1v-1h1zm35 12v-1h1v1zm-5 6h1v1h-1zm0 4v1h-1v-1z",
    fill: "#a8a8a8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v-1h1v4h-1zM56 37h-1v-1h1zm-1 6h1v1h-1zm34 14v1h-1v-1z",
    fill: "#cdcdcd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51v-2h1v2zm1 4v2h-1v-2zm0-11h-1v-1h1zm18 24v1h-1v-1zm2 16v1h-1v-1z",
    fill: "#e0e0e0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1zm34 1h-1v-1h1zm-6 13h-1v-1h1zm13 9h1v1h-1zm1 3h-1v-1h1zm-4 0h1v1h-1zm-23 8h-1v-1h1z",
    fill: "#c6c6c6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h-1v-2h1v1zm35-12v1h-1v-1zm-1 10v1h-1v-1zm-33 7v1h-1v-1zm32 20h1v1h-1zm-29 6v1h-1v-1z",
    fill: "#f9f9f9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1zm-35 2v-1h1v1zm32 4h-1v-1h1zm0 0h1v1h-1zm-29 6v1h-1v-1zm30 25v-1h1v1zm2 9h-1v-1h1z",
    fill: "#fcfcfc"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M85 56h1v6h-1v-1zm0-4h1v1h-1z",
    fill: "#f5f5f6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M64 52h-1v-4h1v1zm20-37h-1v-1h1zm-27 2v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1zm7 10v1h-1v-1zm6 8h-1v-1h1zm19-1h1v1h-1zm7 27h1v1h-1zm-3 3v-1h1v1z",
    fill: "#656565"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1zm25 17h1v1h-1zm-39 3v-1h1v1zm35 14v-1h1v1zm-2 2h1v1h-1zM39 63h1v1h-1z",
    fill: "#6f6f6f"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1zm3 2v-1h1v1zm8 0v1h-1v-1zm9 11v1h-1v-1zM39 63h-1v-1h1zm32 27v1h-1v-1z",
    fill: "#171717"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1zm29 8h1v1h-1zm-9 2v1h-1v-1zm12 7h-1v-1h1zm-10 1h-1v-1h1zm-34 65v1h-1v-1z",
    fill: "#121212"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1zm-44 4v1h-1v-1zm25 13h-1v-1h1zm5 41h-1v-1h1zM42 97v-1h1v1zm-3 2h-1v-1h1z",
    fill: "#5d5d5d"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v1h-1v-1zm37 3v-1h1v1zm7 1h-1v-1h1zm-39 8v1h-1v-1zm-1 59v1h-1v-1zm40 7v1h-1v-1z",
    fill: "#161616"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1zM54 30h1v1h-1zm-4 4h1v1h-1zm20 14v-1h1v1zm6 14h-1v-1h1zm-1 11h1v1h-1z",
    fill: "#070707"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1zm48 1h1v1h-1zm0 7h1v1h-1zm-6 5v-1h1v1zm3 57v1h-1v-1zm1 10h1v1h-1z",
    fill: "#414141"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1zm12 7h-1v-1h1zm41 3v1h-1v-1zm-14 2v1h-1v-1zm-40 2v-1h1v1zm38 58h1v1h-1z",
    fill: "#676767"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1zm13 2h1v1h-1zm-32 8h-1v-1h1zm-7 29h-1v-1h1zm30 32v1h-1v-1zm-35 14v1h-1v-1z",
    fill: "#3a3a3a"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1zM67 35v1h-1v-1zM42 65h1v1h-1zm30 6h1v1h-1zm-3 19h1v1h-1zm4 10h-1v-1h1z",
    fill: "#8b8b8b"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1zm-45 8h1v1h-1zm13 10v1h-1v-1zm-3 8v1h-1v-1zm-1 4h1v1h-1zm31 27h1v1h-1z",
    fill: "#888"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1zm36 0v-1h1v1zm-6 10v-1h1v1zM42 47h-1v-1h1zm36 2h-1v-1h1zm-6 13v1h-1v-1z",
    fill: "#6e6e6e"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1zm-36 1v1h-1v-1zm7 4h-1v-1h1zm-7 2v1h-1v-1zm38 27v-1h1v1zm-2 31h-1v-1h1z",
    fill: "#242424"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1zm-26 9h-1v-1h1zm-13 3v1h-1v-1zm38 33h-1v-1h1zm-36 9v-1h1v1zm3 0v1h-1v-1z",
    fill: "#a4a4a4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1zm0 2h-1v-1h1zm34 0h1v1h-1zM39 59h1v1h-1zm2 30h-1v-1h1zm-5 5v-1h1v1z",
    fill: "#717171"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1zm-34 8h1v1h-1zm34 1h-1v-1h1zM45 63v-1h1v1zm29 9h-1v-1h1zm-24 0v1h-1v-1z",
    fill: "#a0a0a0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1zm5-1v1h-1v-1zM33 35h1v1h-1zm34 2h-1v-1h1zM44 58h-1v-1h1zm28 34v-1h1v1z",
    fill: "#969696"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1zm33 0v1h-1v-1zm-7 32v-1h1v1zm5 15v1h-1v-1zm0 5v1h-1v-1zm-2 15h1v1h-1z",
    fill: "silver"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1zm37 1h1v1h-1zm5 20h-1v-1h1zm-3 3v-1h1v1zM41 72h-1v-1h1zm4 6v1h-1v-1z",
    fill: "#7f7f7f"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1zM72 52h1v1h-1zm1 15h1v1h-1zm0 7v-1h1v1zm-33 1v1h-1v-1zm32 9v-1h1v1z",
    fill: "#898989"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1zm2 1v-1h1v1zm-33 5h1v1h-1zm20 15h1v1h-1zM44 66v1h-1v-1zm34 4v1h-1v-1z",
    fill: "#dcdcdc"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65v-2h1v2zm1-32h-1v-1h1zM43 67v1h-1v-1zm2 3v-1h1v1zm28 15v1h-1v-1z",
    fill: "#f5f5f5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37h1v1h-2v-1zm-3 22v1h-1v-1zm4 22v-1h1v1zm-4 9v1h-1v-1zm31 17h1v1h-1z",
    fill: "#363636"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1zm1 16v1h-1v-1zm-10 8h1v1h-1zm9 2h1v1h-1zM39 79h1v1h-1zm34 12h1v1h-1z",
    fill: "#f6f6f6"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1zm-48 2h-1v-1h1zm1 1h-1v-1h1zm30 1h1v1h-1zM44 82v-1h1v1zm13 3v1h-1v-1z",
    fill: "#c9c9c9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1zm0 12h1v1h-1zm47 6h-1v-1h1zm0 10h-1v-1h1zM69 94h1v1h-1zm3 2v1h-1v-1z",
    fill: "#ececec"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1zM54 72v1h-1v-1zm-14 4v-1h1v1zm3 3v1h-1v-1zm43 1v1h-1v-1zm-44 2h1v1h-1z",
    fill: "#f1f1f1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1zm-2 11h1v1h-1zm2 26v1h-1v-1zm30 0h1v1h-1zM38 98v-1h1v1zm3 2v-1h1v1z",
    fill: "#fbfbfb"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46v-1h1v2h-1zm1 3v1h-1v-1zm-3 2h1v1h-1zm2 29v-1h1v1zm0 5h1v1h-1z",
    fill: "#eaeae9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1zm39 22v1h-1v-1zm-42 4v-1h1v1zm2 5h1v1h-1zm34 20h-1v-1h1zm-30 1h-1v-1h1z",
    fill: "#f8f8f8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1zM42 66h-1v-1h1zm32 13v1h-1v-1zm-31 2h-1v-1h1zm0 3v1h-1v-1zm29 3h1v1h-1z",
    fill: "#eee"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64h1v4h-1v-2zm-33-5h1v1h-1zm17 20v1h-1v-1z",
    fill: "#d0d0d0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92v2h-1v-2zm7-23h1v1h-1zm-32 2v-1h1v1zm-5 15v-1h1v1zm30 11h1v1h-1z",
    fill: "#ededed"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-2h1zm-1 4v-2h1v2zm0 2v-1h1v1zm34 0v1h-1v-1z",
    fill: "#d5d5d6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-3h1v3zm20-82v-1h1v1zm-20 85h1v1h-1z",
    fill: "#949494",
    fillOpacity: 0.047
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53h-1v-2h1v1zm-2-36h-1v-1h1zm1 40h1v1h-1zM49 71h-1v-1h1z",
    fill: "#feffff"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v2h-1v-2zm6 6h1v1h-1zm0 5v1h-1v-1zm3 46h1v1h-1z",
    fill: "#616161"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M57 69v1h-1v-2h1zM45 23h-1v-1h1zm27 35h-1v-1h1zM56 75h1v1h-1z",
    fill: "#c4c4c4"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1zm26 2v-1h1v1zm-26 3h1v1h-1zm-7 17v-1h1v1zm-2 15h1v1h-1z",
    fill: "#4a4a4a"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1zm30 0h-1v-1h1zm-33 2v-1h1v1zm2 47h-1v-1h1zm0 23h-1v-1h1z",
    fill: "#606060"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1zm35 25v1h-1v-1zM45 67h-1v-1h1zm-8 24v1h-1v-1zm6 11v-1h1v1z",
    fill: "#767676"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1zm6 4v1h-1v-1zm-8 3v1h-1v-1zM42 73v1h-1v-1zm3 22v1h-1v-1z",
    fill: "#434343"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1zm-5 34v-1h1v1zM50 70v1h-1v-1zm-7 17v-1h1v1zm-5 3v1h-1v-1z",
    fill: "#777"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1zm-8 31h-1v-1h1zm-30 5v1h-1v-1zm29 13v-1h1v1zM45 90h-1v-1h1z",
    fill: "#bfbfbf"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1zm-15 3h1v1h-1zm34 0v1h-1v-1zm-15 1h1v1h-1zm20 65h-1v-1h1z",
    fill: "#686868"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1zm-22 1h1v1h-1zm29 26h1v1h-1zm-29 5v1h-1v-1zm1 35v-1h1v1z",
    fill: "gray"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1zm35 0v1h-1v-1zm-13 4v-1h1v1zM40 57h1v1h-1zm10 6v-1h1v1z",
    fill: "#acacac"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1zm40 1v1h-1v-1zM76 59v-1h1v1zM41 77v-1h1v1zm33 24v-1h1v1z",
    fill: "#b9b9b9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1zm-33 0h1v1h-1zm-5 2h1v1h-1zm43 19h1v1h-1zm-3 6h1v1h-1z",
    fill: "#939393"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1zm6 16h1v1h-1zm-6 5v1h-1v-1zm6 3h1v1h-1zm21 8h1v1h-1z",
    fill: "#afafaf"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1zm-18 2h-1v-1h1zm2 15v-1h1v1zm4 11v-1h1v1zm37 9v-1h1v1z",
    fill: "#9c9c9c"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1zm8 23v1h-1v-1zm-4 3h-1v-1h1zm39 7v1h-1v-1zm-7 2v1h-1v-1z",
    fill: "#a1a1a1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M75 50v-2h1v2zM43 36h1v1h-1zm35 13v-1h1v1zM47 71v1h-1v-1z",
    fill: "#747474"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v2h-1v-2zm-1 7h1v2h-1v-1zm0-3h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.18
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1zM41 53h-1v-1h1zm33 4v1h-1v-1zM41 84h-1v-1h1zm32 4v1h-1v-1z",
    fill: "#bcbcbc"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M88 47v-2h1v2zm-12-2h-1v-1h1zm12 6h1v1h-1zM75 91h-1v-1h1z",
    fill: "#cbcbcb"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79v3h-1v-3zm-3-32v-1h1v1zM47 72v1h-1v-1z",
    fill: "#7b7b7b"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1zm-1 7h1v1h-1zm6 22v1h-1v-1zm29 0h1v1h-1zM45 92h1v1h-1z",
    fill: "#efefef"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-4h1zm1 53h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1zm9 16h1v1h-1zM40 81h1v1h-1zm37 11h-1v-1h1zm-36 4h-1v-1h1z",
    fill: "#b6b6b6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h-1v-3h1zm-1-6h1v2h-1v-1z",
    fill: "#a6a69c"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v2h-1v-2zm-1 16h1v2h-1v-1zm0-9v-1h1v1z",
    fill: "#ebebea"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M89 59h1v5h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.69
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v2h-1v-2zm-1 9v-2h1v2zm0-4v-1h1v1z",
    fill: "#ececeb"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-2h1v1zm-3 0v-1h1v2h-1zm39-25h-1v-1h1z",
    fill: "#707070"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-4h1v4zm1-6v1h-1v-1z",
    fill: "#787878",
    fillOpacity: 0.067
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-2h1v1zm7-34v1h-1v-1zm-39 93h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h1v1h-1zm43 8v-1h1v1zm-35 9v-1h1v1zm-3 61v-1h1v1z",
    fill: "#858585"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1zm-16 3h1v1h-1zm1 5h1v1h-1zm6 3h-1v-1h1z",
    fill: "#151515"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20h1v3h-1zm0 6v-1h1v1z",
    fill: "#262626",
    fillOpacity: 0.416
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M64 21v1h-1v-2h1zM32 68v1h-1v-2h1z",
    fill: "#636363",
    fillOpacity: 0.09
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1zm14 1v1h-1v-1zm-8 6v-1h1v1zm-32 5v1h-1v-1z",
    fill: "#5c5c5c"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1zm11 14v-1h1v1zm4 36h1v1h-1zm-8 6v1h-1v-1z",
    fill: "#666"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-2v-1h1zM36 31h-1v-1h1zm8 1v1h-1v-1z",
    fill: "#5b5b5b"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1zm0 4h1v1h-1zm0 3v-1h1v1zM31 66h1v1h-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.094
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1zm-39 1h1v1h-1zm6 1v1h-1v-1zm-7 39h1v1h-1z",
    fill: "#646464"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1zm43 46v1h-1v-1zm-7 9h1v1h-1zm-31 5h-1v-1h1z",
    fill: "#696969"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1zm2 2h-1v-1h1zm-2 1v-1h1v1zm5 7v-1h1v1z",
    fill: "#999"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1zm-11 8v-1h1v1zM39 47v-1h1v1zm11 25h-1v-1h1z",
    fill: "#989898"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M89 24h1v4h-1v-1z",
    fill: "#121212",
    fillOpacity: 0.592
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1zm-4 9h1v1h-1zm-2 2v-1h1v1zm43 47v-1h1v1z",
    fill: "#7d7d7d"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v2h-1v-2zm-1-1v-1h1v1zm9 82h1v1h-1z",
    fill: "#464646",
    fillOpacity: 0.184
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1zm-9 8h1v1h-1zm17 0h1v1h-1zm-33 2h1v1h-1z",
    fill: "#909090"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1zm-5 21v1h-1v-1zM41 71h-1v-1h1zm3 13h-1v-1h1z",
    fill: "#dadada"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1zM39 61h-1v-1h1zm0 31h-1v-1h1zm36 10v-1h1v1z",
    fill: "#636363"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1zm19 53h1v1h-1zm5 4h-1v-1h1zm-42 5v-1h1v1z",
    fill: "#737373"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1zm5 8v1h-1v-1zm3 21h1v1h-1zm2 42h-1v-1h1z",
    fill: "#757575"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1zm-21 1h1v1h-1zm-2 3v-1h1v1zm7 41h1v1h-1z",
    fill: "#949494"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1zm37 33h-1v-1h1zm-5 3v1h-1v-1zM42 97h1v1h-1z",
    fill: "#7c7c7c"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1zm-7 18v1h-1v-1zm32 21h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#b4b4b4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1zm-7 17h1v1h-1zm33 27h-1v-1h1zm-3 11h1v1h-1z",
    fill: "#9d9d9d"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32h1v1h-2v-1zm5 28h1v1h-1zm3 37v-1h1v1z",
    fill: "#ababab"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1zm-1 4v-1h1v1zm4 5h-1v-1h1zM44 92v-1h1v1z",
    fill: "#a3a3a3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1zM40 68v-1h1v1zm10 3h1v1h-1zm25 16v-1h1v1z",
    fill: "#8a8a8a"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1zm10 4h-1v-1h1zM41 82v-1h1v1zm2 11h1v1h-1z",
    fill: "#818181"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h1v3h-1zm1-1h-1v-1h1z",
    fill: "#bcbcbc",
    fillOpacity: 0.961
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M58 42v2h-1v-2zm0-5h-1v-1h1zm0 3v1h-1v-1z",
    fill: "#bbb",
    fillOpacity: 0.176
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1zm0 3v-1h1v1zm18 27v1h-1v-1zm9 4h1v1h-1z",
    fill: "#ddd"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-2h1v2zm32-41v-1h1v1zM57 80v1h-1v-1z",
    fill: "#c7c7c7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v2h-1zm0 9v-1h1v1zm33 18v1h-1v-1z",
    fill: "#f3f3f4"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49h-1v-2h1v1zm-1-7h1v1h-1zM39 96h1v1h-1z",
    fill: "#dfdfdf"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1zm29 14h-1v-1h1zm-32 5h1v1h-1zm0 27h1v1h-1z",
    fill: "#b0b0b0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47h-1v-2h1v1zm0 9v1h-1v-1zm-2 2v-1h1v1z",
    fill: "#f3f3f2"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h1v4h-1v-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.933
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53v2h-1v-2zm-1-5h1v1h-1zm-7 14v-1h1v1z",
    fill: "#f6f6f7"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M90 88v1h-1v-2h1zm0-37h-1v-1h1zm0 34v1h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.659
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v2h-1v-1zm0 8v-2h1v2z",
    fill: "#f3f4f3"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1zm-1 27v-1h1v1zm0 12v-1h1v1zm1 1v1h-1v-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.671
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v2h-1v-1zm1 22v1h-1v-2h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.675
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h1v4h-1v-1z",
    fill: "#c3c3c6"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1zm-2 10h-1v-1h1zm23 15v-1h1v1zm3 9h1v1h-1z",
    fill: "#aeaeae"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83h-1v-4h1v1z",
    fill: "#696969",
    fillOpacity: 0.067
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-4h1z",
    fill: "#232323",
    fillOpacity: 0.875
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1zM32 74h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#5d5d5d",
    fillOpacity: 0.075
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-2h1v1zm32-52v1h-1v-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.086
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1zm-3 7v-1h1v1zm-7 44v-1h1v1z",
    fill: "#131313"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-2h1v1zm0 8h-1v-1h1z",
    fill: "#1b1b1b",
    fillOpacity: 0.91
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v3h-1v-3z",
    fill: "#121212",
    fillOpacity: 0.584
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23v2h-1v-2zm-1 0h-1v-1h1z",
    fill: "#b1b1b1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1zM37 38v1h-1v-1zm0 61h-1v-1h1z",
    fill: "#0a0a0a"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h1v3h-1z",
    fill: "#666",
    fillOpacity: 0.098
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1zM42 47v-1h1v1zm0 13v-1h1v1z",
    fill: "#7e7e7e"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1zm5 1h-1v-1h1zm-4 42v1h-1v-1z",
    fill: "#bdbdbd"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1zm-7 8v-1h1v1zm37 61h-1v-1h1z",
    fill: "#9f9f9f"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25h1v3h-1v-1z",
    fill: "#070707",
    fillOpacity: 0.965
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1zM70 60v1h-1v-1zm1 29h1v1h-1z",
    fill: "#b8b8b8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1zM42 57v-1h1v1zm32 40h1v1h-1z",
    fill: "#bbb"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26h1v2h-1v-1zm0 3h1v1h-1z",
    fill: "#282828",
    fillOpacity: 0.42
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1zm0 2h-1v-1h1zM32 62v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.91
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1zm-7 8h-1v-1h1zm3 19h1v1h-1z",
    fill: "#919191"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1zm-9 55v1h-1v-1zm2 14v-1h1v1z",
    fill: "#a2a2a2"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1zm-3 4v1h-1v-1zm6 31h1v1h-1z",
    fill: "#9a9a9a"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1zm38 1h-1v-1h1zM51 73h-1v-1h1z",
    fill: "#878787"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1zm0 43v1h-1v-1zm-2 16v-1h1v1z",
    fill: "#727272"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1zm-1 16h-1v-1h1zm9 33h1v1h-1z",
    fill: "#d5d6d6"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1zm5 8h-1v-1h1zm2 29v1h-1v-1z",
    fill: "#7a7a7a"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1zm0 11h-1v-1h1zm0 8h1v1h-1z",
    fill: "#f3f4f2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1zm0 62h1v1h-1zm-31 4h-1v-1h1z",
    fill: "#020000"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M57 44h-1v-3h1z",
    fill: "#bdbdbd",
    fillOpacity: 0.961
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1zm0 4v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#f3f3f5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1zm0 10h1v1h-1zm1 29h-1v-1h1z",
    fill: "#eaeaeb"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1zm1 7h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#f3f4f4"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1zm0 12v-1h1v1zm1 3v1h-1v-1z",
    fill: "#eaeae8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M57 47v3h-1v-3z",
    fill: "#bebebe",
    fillOpacity: 0.969
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50v-1h1v2h-1zm2-2v-1h1v1z",
    fill: "#e9eae9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1zM41 59h-1v-1h1zm0 22v-1h1v1z",
    fill: "#787878"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1zm8 21h1v1h-1zm27 16h-1v-1h1z",
    fill: "#e5e5e5"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-2h1v2zm0 6v-1h1v1z",
    fill: "#c4c4c5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-3h1v1z",
    fill: "#575757",
    fillOpacity: 0.125
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1zm1 19v-1h1v1zm32 4v-1h1v1z",
    fill: "#f2f2f3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1zm-1 29h1v1h-1zm0 10h1v1h-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.667
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1zm36 34h1v1h-1zm0 6h1v1h-1z",
    fill: "#d9d9d9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M85 56v1h-1v-2h1zm0-3v1h-1v-1z",
    fill: "#e9eaea"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M33 60h-1v-3h1z",
    fill: "#1e1e1e",
    fillOpacity: 0.918
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1zm1 2v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#5b5b5b",
    fillOpacity: 0.098
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70v-1h1v2h-1zm0-4h1v1h-1z",
    fill: "#bababa",
    fillOpacity: 0.682
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1zm5 0v-1h1v1zm25 14h1v1h-1z",
    fill: "#959595"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M58 72v3h-1v-3z",
    fill: "#b8b8b8",
    fillOpacity: 0.282
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v3h-1v-3z",
    fill: "#202020",
    fillOpacity: 0.882
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v2h-1v-2zm0 4v1h-1v-1z",
    fill: "#636363",
    fillOpacity: 0.071
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1zm1 9h1v1h-1zm32 5h1v1h-1z",
    fill: "#f0f0ef"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1zm-29 4v-1h1v1zm25 7v1h-1v-1z",
    fill: "#eeeeef"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 80h1v2h-1v-1zm0-3v-1h1v1z",
    fill: "#f0f1f0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M65 82h-1v-3h1z",
    fill: "#353535",
    fillOpacity: 0.655
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-2h1v2zm1 2v1h-1v-1z",
    fill: "#efeff0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h1v2h-1v-1zm0 4v-1h1v1z",
    fill: "#252525",
    fillOpacity: 0.875
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-2h1v1zm0-7h-1v-1h1z",
    fill: "#373737",
    fillOpacity: 0.651
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v2h-1v-2zm0 3v1h-1v-1z",
    fill: "#373737",
    fillOpacity: 0.647
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v2h-1v-2zm-29 17h-1v-1h1z",
    fill: "#ec4042"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100v-2h1v2zm1-7v1h-1v-1z",
    fill: "#898989",
    fillOpacity: 0.051
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-2h1zm0 6h-1v-1h1z",
    fill: "#3a3a3a",
    fillOpacity: 0.627
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h2v1h-2z",
    fill: "#8e8e91",
    fillOpacity: 0.337
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14h1v1h-1zM32 73h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.078
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h1v1h-1zm32 30h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1zm-23 93h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1zm-36 8h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.412
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1zM53 33h1v1h-1z",
    fill: "#929392"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1zM49 74v-1h1v1z",
    fill: "#8a8a8c"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v1h-1zm-4 22v1h-1v-1z",
    fill: "#434444"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M53 19h-2v-1h2z",
    fill: "#131312"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v2h-1v-1z",
    fill: "#050505",
    fillOpacity: 0.941
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M89 18h1v2h-1v-1z",
    fill: "#0f0f0f",
    fillOpacity: 0.576
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1zm27 0v1h-1v-1z",
    fill: "#222221"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1zm7 85v1h-1v-1z",
    fill: "#020201"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1zm-3 15v1h-1v-1z",
    fill: "#3f3f3e"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22v2h-1v-2z",
    fill: "#070707",
    fillOpacity: 0.957
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.91
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1zm-6 48v1h-1v-1z",
    fill: "#b7b7b7"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1zM32 61v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.914
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1zm39 0v1h-1v-1z",
    fill: "#b5b5b5"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1zm-11 8v1h-1v-1z",
    fill: "#929292"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1zm-5 65v-1h1v1z",
    fill: "#a7a7a7"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-2h1z",
    fill: "#1c1c1c",
    fillOpacity: 0.914
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1zM67 36v-1h1v1z",
    fill: "#838383"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1zm28 55v1h-1v-1z",
    fill: "#8c8c8c"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#6a6a6a",
    fillOpacity: 0.094
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1zm-3 53v1h-1v-1z",
    fill: "#424242"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1zm-21 80h-1v-1h1z",
    fill: "#121212",
    fillOpacity: 0.6
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#111",
    fillOpacity: 0.612
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1zm8 12v-1h1v1z",
    fill: "#797979"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1zm38 10h-1v-1h1z",
    fill: "#848484"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1zm34 3h1v1h-1z",
    fill: "#cececf"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#a9a9a9"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1zm-1 10v-1h1v1z",
    fill: "#afb1ad"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1zm-1 53v1h-1v-1z",
    fill: "#aaa"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1zm0 5h-1v-1h1z",
    fill: "#f5f4f6"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v2h-1z",
    fill: "#f3f4f5"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41h-1v-2h1v1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v2h-1v-2z",
    fill: "#3a3a3a",
    fillOpacity: 0.835
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1zm-1 3h1v1h-1z",
    fill: "#c5c5c4"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#ebebed"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40v-1h1v2h-1z",
    fill: "#f7f6f6"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1zm36 56v1h-1v-1z",
    fill: "#d9d7d9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1zm-1 21v-1h1v1z",
    fill: "#d5d6d8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1zm33 23h-1v-1h1z",
    fill: "#f5f4f5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1zm-1 9h1v1h-1z",
    fill: "#c4c5c4"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1zm-7 36h-1v-1h1z",
    fill: "#f6f8f8"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#bdbdbd",
    fillOpacity: 0.965
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46h1v2h-1v-1z",
    fill: "#d6d6d7"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1zm-2 45v-1h1v1z",
    fill: "#a6a6a6"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h-1v-2h1v1z",
    fill: "#b4b4b4",
    fillOpacity: 0.188
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49v-1h1v2h-1z",
    fill: "#4f4f4f",
    fillOpacity: 0.125
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1zm26 12h-1v-1h1z",
    fill: "#f2f3f3"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1zm-3 47v1h-1v-1z",
    fill: "#e6e6e6"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-2h1v2z",
    fill: "#b9b9b9",
    fillOpacity: 0.651
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1zm1 11h-1v-1h1z",
    fill: "#fdfefd"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1zm-4 15v-1h1v1z",
    fill: "#b3b3b3"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1zm0 7v1h-1v-1z",
    fill: "#a6a79c"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-2h1z",
    fill: "#f6f6f4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1zm0 3h1v1h-1z",
    fill: "#afafae"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1zm45 46v1h-1v-1z",
    fill: "#d9d8d9"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1zm2 24v-1h1v1z",
    fill: "#eaebea"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#afb0ac"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M64 54v-1h1v2h-1z",
    fill: "#353535",
    fillOpacity: 0.749
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1zm1 30h-1v-1h1z",
    fill: "#fdffff"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v2h-1v-1z",
    fill: "#c5c5c6"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1zm-1 36h1v1h-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.678
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1zm0 17h1v1h-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.675
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v2h-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.106
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58v1h-1v-2h1z",
    fill: "#b8b285"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1zm37 37h1v1h-1z",
    fill: "#d5d5d4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59h1v2h-1v-1z",
    fill: "#d4d4d5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v2h-1v-2z",
    fill: "#e8e9e7"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h1v2h-1v-1z",
    fill: "#f1f1f4"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h-1v-2h1v1z",
    fill: "#323232",
    fillOpacity: 0.71
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-2h1v1z",
    fill: "#515151",
    fillOpacity: 0.098
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v2h-1v-2z",
    fill: "#1e1e1e",
    fillOpacity: 0.91
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#b9b9b9",
    fillOpacity: 0.259
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v2h-1v-1z",
    fill: "#333",
    fillOpacity: 0.702
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1zM42 90h1v1h-1z",
    fill: "#bababa"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-2h1z",
    fill: "#a5a596"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-2h1v2z",
    fill: "#c3c4c6"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1zM45 85v1h-1v-1z",
    fill: "#f5f6f6"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v2h-1v-1z",
    fill: "#b5b5b5",
    fillOpacity: 0.259
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1zm-8 2v-1h1v1z",
    fill: "#f1f2f1"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v2h-1z",
    fill: "#bababa",
    fillOpacity: 0.686
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66v-1h1v2h-1z",
    fill: "#f2f1f3"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-2h1v1z",
    fill: "#c2c2c4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1zM52 83v-1h1v1z",
    fill: "#ecedec"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1zM41 85h1v1h-1z",
    fill: "#8d8d8d"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1zm0 14h-1v-1h1z",
    fill: "#d7d7d8"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1zm0 3v-1h1v1z",
    fill: "#353535",
    fillOpacity: 0.69
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M89 68v-1h1v2h-1z",
    fill: "#bbb",
    fillOpacity: 0.682
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1zm31 13v-1h1v1z",
    fill: "#f1f2f2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68h1v2h-1v-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.271
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1zm8 20v1h-1v-1z",
    fill: "#efedeb"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73v-2h1v2z",
    fill: "#b9b9b9",
    fillOpacity: 0.678
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1zm-1 3v-1h1v1z",
    fill: "#f0f0f1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-2h1z",
    fill: "#e8e8e7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1zm32 12v-1h1v1z",
    fill: "#f1f0f2"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1zm0 4h1v1h-1z",
    fill: "#333",
    fillOpacity: 0.663
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-2h1z",
    fill: "#b4b4b4",
    fillOpacity: 0.282
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1zm0 2v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.659
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#eaebe9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-2h1v2z",
    fill: "#222",
    fillOpacity: 0.882
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1zm1 9h-1v-1h1z",
    fill: "#ededef"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1zm0 7h-1v-1h1z",
    fill: "#717171",
    fillOpacity: 0.071
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1zm32-1v1h-1v-1z",
    fill: "#f1f1f2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v2h-1v-2z",
    fill: "#b5b5b5",
    fillOpacity: 0.298
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82v-1h1v1zm1 1v1h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.663
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h1v1h-1zm0 8v-1h1v1z",
    fill: "#bbb",
    fillOpacity: 0.663
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1zm0 6v1h-1v-1z",
    fill: "#e4e3e3"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-2h1v2z",
    fill: "#363636",
    fillOpacity: 0.655
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M87 83v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#eae9e9"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1zm33 12v1h-1v-1z",
    fill: "#fffeff"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-2h1v2z",
    fill: "#eeeff1"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1zm-32 3v-1h1v1z",
    fill: "#e73d3b"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1zm-32 3v-1h1v1z",
    fill: "#de6b31"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h-1v-2h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.063
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1zm5 4h-1v-1h1z",
    fill: "#e7e7e7"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M57 92v1h-1v-2h1z",
    fill: "#cbcbca"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92v2h-1v-2z",
    fill: "#e8e8ea"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v1h-1v-2h1z",
    fill: "#e63a3a"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95v1h-1v-2h1z",
    fill: "#cdcdca"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M88 95v-1h1v2h-1z",
    fill: "#d5d4d2"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1zm-31 8h-1v-1h1z",
    fill: "#e93c3d"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95h1v2h-1v-1z",
    fill: "#d8d7db"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1zm0 6h-1v-1h1z",
    fill: "#cdcccc"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v2h-1v-2z",
    fill: "#3a3a3a",
    fillOpacity: 0.62
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1zm-32 3v-1h1v1z",
    fill: "#ea3f40"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v2h-1v-1z",
    fill: "#292929",
    fillOpacity: 0.843
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99v2h-1v-2z",
    fill: "#b2b5b2",
    fillOpacity: 0.408
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101v2h-1v-2z",
    fill: "#ea3d3d"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106v1h-1v-2h1z",
    fill: "#010001"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h2v1h-2z",
    fill: "#010102"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M80 107v1h-1v-2h1z",
    fill: "#010201"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1zm-15 1h1v1h-1z",
    fill: "#333",
    fillOpacity: 0.078
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1zm31 0v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.925
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v1h-2v-1h1z",
    fill: "#020202",
    fillOpacity: 0.953
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1zm5 0h-1v-1h1z",
    fill: "#020202",
    fillOpacity: 0.984
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109h1v1h-2v-1z",
    fill: "#181818",
    fillOpacity: 0.161
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-1v-1z",
    fill: "#787878",
    fillOpacity: 0.075
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1z",
    fill: "#606060",
    fillOpacity: 0.114
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-1v-1h1z",
    fill: "#94949a",
    fillOpacity: 0.169
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#989ca0",
    fillOpacity: 0.243
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#939396",
    fillOpacity: 0.298
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h-1v-1h1z",
    fill: "#999996",
    fillOpacity: 0.306
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#b0b0b0",
    fillOpacity: 0.267
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1z",
    fill: "#929292",
    fillOpacity: 0.231
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#4e4e4e",
    fillOpacity: 0.192
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#4f4f57",
    fillOpacity: 0.125
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#686868",
    fillOpacity: 0.086
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1z",
    fill: "#757575",
    fillOpacity: 0.051
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#797979",
    fillOpacity: 0.082
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#a2a2a2",
    fillOpacity: 0.129
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#8f8f94",
    fillOpacity: 0.188
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1z",
    fill: "#919191",
    fillOpacity: 0.227
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1z",
    fill: "#898989",
    fillOpacity: 0.239
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1z",
    fill: "#8b8b8f",
    fillOpacity: 0.216
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1z",
    fill: "#9e9e9e",
    fillOpacity: 0.176
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1z",
    fill: "#b6b6ae",
    fillOpacity: 0.137
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M81 15h-1v-1h1z",
    fill: "#717171",
    fillOpacity: 0.106
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h1v1h-1z",
    fill: "#8d8d8d",
    fillOpacity: 0.035
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#353535",
    fillOpacity: 0.243
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#222",
    fillOpacity: 0.412
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#212121",
    fillOpacity: 0.569
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#2b2b2b",
    fillOpacity: 0.69
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1z",
    fill: "#454546",
    fillOpacity: 0.796
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#5b5b5e",
    fillOpacity: 0.878
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#737478",
    fillOpacity: 0.918
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#999ba0",
    fillOpacity: 0.953
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1z",
    fill: "#b7bbbe",
    fillOpacity: 0.996
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#a6a8ab"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1z",
    fill: "#b8b8bc"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#c9c8cc"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15v1h-1v-1z",
    fill: "#c4c3c5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16h-1v-1h1z",
    fill: "#b2b1b3"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h-1v-1h1z",
    fill: "#8f8e90",
    fillOpacity: 0.988
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15v1h-1v-1z",
    fill: "#4d4c4e",
    fillOpacity: 0.973
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1z",
    fill: "#414046",
    fillOpacity: 0.925
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#39383c",
    fillOpacity: 0.89
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#38383a",
    fillOpacity: 0.835
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15h1v1h-1z",
    fill: "#2e2e2e",
    fillOpacity: 0.737
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#202020",
    fillOpacity: 0.62
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#222",
    fillOpacity: 0.459
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#313131",
    fillOpacity: 0.243
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.267
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#232323",
    fillOpacity: 0.557
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#353435",
    fillOpacity: 0.686
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#464648",
    fillOpacity: 0.776
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1z",
    fill: "#616264",
    fillOpacity: 0.843
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#797b80",
    fillOpacity: 0.89
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#afb1b5",
    fillOpacity: 0.929
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#aaadae",
    fillOpacity: 0.969
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1z",
    fill: "#a3a3a5",
    fillOpacity: 0.984
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1z",
    fill: "#b7b7b9",
    fillOpacity: 0.988
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1z",
    fill: "#bebec0",
    fillOpacity: 0.976
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h-1v-1h1z",
    fill: "#b7b6b8",
    fillOpacity: 0.961
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h-1v-1h1z",
    fill: "#a8a7a9",
    fillOpacity: 0.933
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16h-1v-1h1z",
    fill: "#626163",
    fillOpacity: 0.914
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v-1h1v1z",
    fill: "#3c3c3e",
    fillOpacity: 0.882
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15h1v1h-1z",
    fill: "#343436",
    fillOpacity: 0.824
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1z",
    fill: "#2f2f30",
    fillOpacity: 0.761
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v-1h1v1z",
    fill: "#2e3030",
    fillOpacity: 0.686
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#222",
    fillOpacity: 0.573
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#232323",
    fillOpacity: 0.447
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#393939",
    fillOpacity: 0.278
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1z",
    fill: "#727272",
    fillOpacity: 0.078
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1z",
    fill: "#4e4e4e",
    fillOpacity: 0.102
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h-1v-1h1z",
    fill: "#151515",
    fillOpacity: 0.729
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#080808",
    fillOpacity: 0.988
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1z",
    fill: "#a1a2a3"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#a0a0a5"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#9e9fa4"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#babbc2"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1z",
    fill: "#d7d8de"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#bcbcc1"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#e5e5e9"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#edecee"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1z",
    fill: "#c3c3c7"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M48 17h-1v-1h1z",
    fill: "#a8a8ad"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1z",
    fill: "#97999e"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#929199"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#8d8c93"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16v1h-1v-1z",
    fill: "#908f94"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17v-1h1v1z",
    fill: "#939396"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#060606",
    fillOpacity: 0.984
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#121212",
    fillOpacity: 0.553
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#232323",
    fillOpacity: 0.31
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#0a0a0a",
    fillOpacity: 0.855
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#9fa0a1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#a0a1a5"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#a6a7ad"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#cfd1d7"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#cccfd2"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v1h-1v-1z",
    fill: "#c3c5c8"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16v1h-1v-1z",
    fill: "#d2d2d7"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h1v1h-1z",
    fill: "#b2b3b7"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h1v1h-1z",
    fill: "#9d9da2"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1z",
    fill: "#8f9095"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#8b8a90"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1z",
    fill: "#868589"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#7b7b7c"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#0f0f0f",
    fillOpacity: 0.851
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#3a3a3a",
    fillOpacity: 0.224
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1z",
    fill: "#262626",
    fillOpacity: 0.365
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#5e6060"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#696a6d"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17h1v1h-1z",
    fill: "#717175"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1z",
    fill: "#85858a"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#95949a"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#8e8d92"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1z",
    fill: "#9b9a9d"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17h1v1h-1z",
    fill: "#b3b3b2"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h1v1z",
    fill: "#a8a8ab"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#909196"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1z",
    fill: "#84868b"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h1z",
    fill: "#7e7e84"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v1h-1v-1z",
    fill: "#7a797e"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#6b6b6d"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-1v-1z",
    fill: "#59595a"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#070707",
    fillOpacity: 0.906
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#484848",
    fillOpacity: 0.082
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#999",
    fillOpacity: 0.02
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#101010",
    fillOpacity: 0.792
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#666766"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#6e6f70"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#77787b"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#828287"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#9f9fa4"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#9c9da1"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#9d9ea1"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-1z",
    fill: "#b4b5b5"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#c2c4c3"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#bcbdc0"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1z",
    fill: "#a7a8ac"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M81 18h-1v-1h1z",
    fill: "#909095"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1z",
    fill: "#87888d"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#85848b"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#7f7f84"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#747477"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#1a1a1a",
    fillOpacity: 0.533
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1z",
    fill: "#212121",
    fillOpacity: 0.42
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1z",
    fill: "#070708"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-1v-1z",
    fill: "#09090b"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1z",
    fill: "#0f0f12"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1z",
    fill: "#1e1e21"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1z",
    fill: "#313133"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1z",
    fill: "#363637"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#464645"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#4d4d4f"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#535356"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#4f5051"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#323233"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1z",
    fill: "#151514"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#343434",
    fillOpacity: 0.133
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#5a5a5a",
    fillOpacity: 0.067
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#111",
    fillOpacity: 0.882
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#0b0c0c"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#0c0c0d"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1z",
    fill: "#111013"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#1a1a1d"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#2e2d30"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#373739"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#4b4b4c"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19v-1h1v1z",
    fill: "#535355"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#57565a"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1z",
    fill: "#4f4e52"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#414043"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1z",
    fill: "#262629"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1z",
    fill: "#0f0f10"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#232323",
    fillOpacity: 0.424
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1z",
    fill: "#1a1a19"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#10100f"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#242322"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#222122"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#212122"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#1e1f1e"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#0f100f"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#3f3f3f",
    fillOpacity: 0.141
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.902
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1z",
    fill: "#282827"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#252526"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#1a1a1b"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#0d0d0c"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#040403"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#212120"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#060606",
    fillOpacity: 0.945
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#434343",
    fillOpacity: 0.149
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#090908"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#121211"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-1v-1h1z",
    fill: "#121212",
    fillOpacity: 0.58
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#000001"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#060606",
    fillOpacity: 0.949
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#464646",
    fillOpacity: 0.157
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#474747",
    fillOpacity: 0.169
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#272727",
    fillOpacity: 0.408
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#494949",
    fillOpacity: 0.176
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#070707",
    fillOpacity: 0.961
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#484848",
    fillOpacity: 0.18
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#4b4b4b",
    fillOpacity: 0.184
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#282828",
    fillOpacity: 0.416
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#060606",
    fillOpacity: 0.965
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#040404",
    fillOpacity: 0.969
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#424242",
    fillOpacity: 0.196
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#383838",
    fillOpacity: 0.408
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#1b1b1b",
    fillOpacity: 0.961
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#636363",
    fillOpacity: 0.18
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#797979",
    fillOpacity: 0.09
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#232323",
    fillOpacity: 0.91
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#262626",
    fillOpacity: 0.6
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#8d8d8d",
    fillOpacity: 0.388
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#adadad",
    fillOpacity: 0.949
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#c4c4c4",
    fillOpacity: 0.153
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#aaa",
    fillOpacity: 0.082
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "gray",
    fillOpacity: 0.898
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#acacac",
    fillOpacity: 0.584
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#707070",
    fillOpacity: 0.4
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#a4a4a5"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#d2d1d1"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#f7f7f6"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#959595",
    fillOpacity: 0.969
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.188
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.086
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.902
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#646465"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#a1a1a2"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#8a8a8b"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#929292",
    fillOpacity: 0.592
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#242424",
    fillOpacity: 0.408
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#dfdfde"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#cfcfce"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#aaaaab"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#949595"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#a7a6a6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#aaabaa"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#090909",
    fillOpacity: 0.98
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#3b3b3b",
    fillOpacity: 0.22
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.094
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#212121",
    fillOpacity: 0.914
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#e0e0e1"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#e3e3e2"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#c0c0bf"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#a2a2a3"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#9f9fa0"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#464646",
    fillOpacity: 0.369
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#545455"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#5f5f5e"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#323331"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#111211"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#1c1d1c"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#323232",
    fillOpacity: 0.965
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#777",
    fillOpacity: 0.184
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#858585",
    fillOpacity: 0.082
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.898
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#383838",
    fillOpacity: 0.588
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#8d8d8d",
    fillOpacity: 0.353
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#4d4d4e"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#5c5c5d"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#5c5d5c"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#3a3a38"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#212321"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#383a39"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#686969"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.957
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.173
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#a5a5a5",
    fillOpacity: 0.078
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#898989",
    fillOpacity: 0.894
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#4e4e4f"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#575858"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#181919"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#b6b6b6",
    fillOpacity: 0.576
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.302
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#c0c1bf"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#cecccd"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#b0aaa7"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#a09d94"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#d7d9d7"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#f8f8fa"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#fbfafb"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#c6c6c6",
    fillOpacity: 0.071
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#5a5a5a",
    fillOpacity: 0.882
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#979797"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#c4c4c2"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#b7b4b3"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#9d9993"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#9d9b99"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#bcbcbd"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#f9f9f8"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#b5b5b5",
    fillOpacity: 0.588
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#646464",
    fillOpacity: 0.278
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#656564"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#6a6867"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#705f5d"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#b4886d"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#cab691"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#b5b3ac"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#bababa",
    fillOpacity: 0.961
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#efefef",
    fillOpacity: 0.063
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#3a3a3a",
    fillOpacity: 0.867
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#727271"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#807f7c"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#7e7a79"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#9b7a6f"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#cbab85"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#b7b09e"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#c5c6c9"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#ebeced"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#f7f8f6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.592
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#646464",
    fillOpacity: 0.259
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.996
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#220300"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#b66a3e"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#dabf83"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#b5b2a9"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#d7d7db"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#f3f5f2"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#3c3c3c",
    fillOpacity: 0.847
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#6f2f1c"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#e1aa6a"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#bcb497"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#c3c4c3"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#eaebec"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#b5b5b5",
    fillOpacity: 0.596
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#626262",
    fillOpacity: 0.243
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.992
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#030402"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#340d0d"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#cb7046"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#d8be7b"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#b5b3ab"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#d7d7da"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#f2f4f3"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#b5b5b5",
    fillOpacity: 0.176
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#070000"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#8a3929"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#e8ab69"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#b9b291"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.6
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#606060",
    fillOpacity: 0.239
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.992
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#7b7d7d"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#3c3c3d"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#3c100a"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#d17a47"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#d3be7c"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#b4b2ac"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#d9d8d8"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#f6f4f5"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#686869"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#5c5a5f"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#140b0a"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#944029"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#e6b36b"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#b6b090"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#c6c5c7"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#ecebf0"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#b7b7b7",
    fillOpacity: 0.604
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.227
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.988
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#858587"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#7c7a7d"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#5c2922"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#d18144"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#d0bb7f"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#b3b1a9"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#f5f4f3"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#383838",
    fillOpacity: 0.831
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#949493"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#828487"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#594748"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#942"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#e4b66b"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#b3ad93"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#c6c5c5"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#eceaee"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#f7f6f5"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.612
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#606060",
    fillOpacity: 0.208
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.98
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#858584"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#979698"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#7a7578"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#70352f"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#d58347"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#cdb881"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#b2b1ad"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#d7d6d9"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#3a3a3a",
    fillOpacity: 0.816
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#9e9d9c"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#858688"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#6a5152"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#a44b2a"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#e3b66c"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#b3ab94"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#eaeaed"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#f5f7f6"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.616
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#5a5a5a",
    fillOpacity: 0.188
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#1e1e1e",
    fillOpacity: 0.973
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#030304"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#373636"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#868587"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#6c6969"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#662620"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#dc8c4f"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#cab984"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#b0b2ae"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#f5f5f7"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#383838",
    fillOpacity: 0.8
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#8c8e90"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#573839"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#ad5231"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#e4b972"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#b0ac97"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#d3d2d2"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.624
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.165
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#1e1e1e",
    fillOpacity: 0.961
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#3a3939"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#0e0e0f"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#6d2923"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#df9053"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#c5b884"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#aeb2ac"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#d4d7d5"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#f4f4f2"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.796
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#151615"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#111213"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#2b0b0b"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#ba5d3d"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#e0bb74"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#abab97"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#c3c5c4"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#eae9eb"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#f8f7f8"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.624
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.153
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#1d1d1d",
    fillOpacity: 0.949
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#9c9c9e"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#2d292a"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#7a2b23"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#e49555"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#c1b686"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#d5d7d6"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#f3f2f2"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#bcbcbc",
    fillOpacity: 0.965
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#363636",
    fillOpacity: 0.788
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#b6b6b7"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#434443"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#3b1114"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#c26240"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#dfbc76"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#aaa899"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#c3c6c5"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#f7f5f7"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.631
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#525252",
    fillOpacity: 0.145
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#1c1c1c",
    fillOpacity: 0.945
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#ada4a6"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#842e26"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#ea9857"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#bfb489"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#b0b1b0"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#f3f2f4"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#b8b8b8",
    fillOpacity: 0.184
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#343434",
    fillOpacity: 0.78
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#eceeed"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#693b3c"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#c8643d"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#e0bc78"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#aaa89d"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#c4c5c9"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#f7f6f9"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.639
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#525252",
    fillOpacity: 0.133
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#1c1c1c",
    fillOpacity: 0.937
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#919190"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#eeefef"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#bbaeb0"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#8a3128"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#ea9e57"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#bcb38b"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#afaeb1"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#353535",
    fillOpacity: 0.773
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#f8faf8"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#754344"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#cd693b"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#debe7a"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#a7a69e"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#c4c4c9"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#ece9eb"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#f6f6f9"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#b9b9b9",
    fillOpacity: 0.647
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#a0a1a0"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#5a5c5c"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#635556"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#8e352a"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#e7a358"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#b9b389"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#afafb0"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#d7d6d3"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#343434",
    fillOpacity: 0.765
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#6c3839"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#cd6e3a"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#d9c07b"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#a6a69e"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#c4c4c8"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#ece9e9"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#cdced0"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#2a1d1e"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#8b3729"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#e7a65c"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#b9b388"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#d6d7d4"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#f3f4f0"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.192
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#353535",
    fillOpacity: 0.765
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#535555"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#471113"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#d17442"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#d8c17c"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#9e9293"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#853929"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#e6a75d"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#b9b288"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#f2f2f1"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#f4f3f5"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#bebebe",
    fillOpacity: 0.973
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#b2b2b2",
    fillOpacity: 0.196
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#343434",
    fillOpacity: 0.757
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#8b8a8a"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#d9dbdb"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#653536"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#cc7442"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#d7c07c"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#a6a79b"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#d2cbcc"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#763726"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#e4ab61"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#b8b187"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#aeafa9"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#d6d5d7"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.973
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#b5b5b5",
    fillOpacity: 0.204
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#333",
    fillOpacity: 0.757
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#908f8f"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#7b5654"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#be6f3d"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#d6c17d"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#a6a799"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#f5f5f4"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.933
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#787978"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#cdcdcc"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#ddd9da"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#6b3625"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#e1ac61"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#b8b088"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#afb1a7"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#d6d6da"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "silver",
    fillOpacity: 0.976
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.208
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#363636",
    fillOpacity: 0.757
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#878888"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#7f7e7e"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#816462"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#b16a38"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#d7c27f"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#a6a798"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#5a5a5a",
    fillOpacity: 0.122
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#1e1e1e",
    fillOpacity: 0.929
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#d8d6d8"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#6a3a25"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#e3af62"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#b9af88"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#f2f2f5"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.98
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#b4b4b4",
    fillOpacity: 0.216
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#fcfcfb"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#7e6666"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#af703a"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#d9c17e"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#a6a59a"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#c4c5c5"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.118
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.929
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#f6f7f6"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#bbadae"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#7d3923"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#e8b164"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#b8af8b"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#f3f2f6"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#bebebe",
    fillOpacity: 0.98
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#b1b1b1",
    fillOpacity: 0.22
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#f6f8f5"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#764947"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#c37a40"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#d5c280"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#4f4f4f",
    fillOpacity: 0.114
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#1d1d1d",
    fillOpacity: 0.925
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#4b4c4b"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#6e7072"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#432728"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#a74a34"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#ecad60"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#b7b08b"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#afb0ae"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#f2f2f6"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "silver",
    fillOpacity: 0.98
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#b6b6b6",
    fillOpacity: 0.22
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#343434",
    fillOpacity: 0.741
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#818282"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#5e5756"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#722d2a"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#dc8045"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#d4c180"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#515151",
    fillOpacity: 0.11
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#1d1d1d",
    fillOpacity: 0.922
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#adadb0"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#5d494c"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#953d28"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#ebb05d"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#b8b188"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#d5d6d2"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "silver",
    fillOpacity: 0.984
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.227
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#333",
    fillOpacity: 0.737
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#808281"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#6e6869"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#692926"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#d88043"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#d5c27b"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#353635"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#fcfdfc"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#beb6b6"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#813925"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#ecb45e"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#d6d6d4"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#e1e1e2"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "silver",
    fillOpacity: 0.988
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#b6b6b6",
    fillOpacity: 0.235
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#353535",
    fillOpacity: 0.729
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#acadae"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#6e433e"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#cf8041"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#d5c579"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#c4c4c6"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#b8b8b8",
    fillOpacity: 0.682
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#a7a8a7"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#f4f5f3"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#bbb4b2"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#803b27"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#ebb25d"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#aeaeb0"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "silver",
    fillOpacity: 0.992
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.243
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#343434",
    fillOpacity: 0.725
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#bebfbf"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#f6f9f9"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#6e4743"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#cf7f40"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#d6c578"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#e9eae7"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#b9b9b9",
    fillOpacity: 0.686
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.106
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#bbb2b1"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#813b27"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#edb35e"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#b9b485"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#aeaeaf"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#f1f1f3"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#c1c1c1",
    fillOpacity: 0.992
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.243
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.718
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#6e4641"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#d07f41"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#d8c679"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#bbb2b0"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#813927"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#edb15e"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#bbb587"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#c1c1c1",
    fillOpacity: 0.996
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#b6b6b6",
    fillOpacity: 0.247
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#6f4642"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#cf7c3f"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#d9c67a"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#a6a69d"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#b7b7b6"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#bcb4b2"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#7f3827"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#ebb25c"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#bbb585"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#aeafae"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#d5d4d7"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "silver",
    fillOpacity: 0.996
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.255
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#dbdbdb"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#704541"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#cd7c3f"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#dac778"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#a6a79a"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#aaa1a0"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#813929"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#eab15a"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#bbb685"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#d6d6d9"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#7f8180"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#714642"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#cb7b3f"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#dbc778"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#ebeaea"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#ebeceb"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#929393"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#4c4343"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#803527"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#ecae5a"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#bfb885"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#acacaa"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#f2f2f0"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#a4a6a4"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#5e5f5b"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#542826"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#cc7b41"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#dec979"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#eae9ea"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#585858",
    fillOpacity: 0.102
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.914
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#b4abac"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#813528"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#eba856"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#c4ba82"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#abaca6"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#d1d5d7"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#343434",
    fillOpacity: 0.706
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#e7e5e5"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#6b3c3e"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#cb753b"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#e1c976"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#a7a697"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#c1c2c4"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.914
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#949594"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#c5bbbf"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#853428"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#eba553"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#c5bc7c"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#acada8"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#d1d3d3"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#f4f4f3"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.698
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#fcfbfc"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#78474b"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#c97035"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#e4c973"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#a8a795"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#e9e7e8"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#1f1f1f",
    fillOpacity: 0.91
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#565455"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#6e6664"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#7f3828"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#e9a750"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#c8c076"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#adaca8"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#d4d4d2"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#f3f3f1"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.263
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#353535",
    fillOpacity: 0.698
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#838480"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#673b3d"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#c77339"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#e8ca6e"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#a9a88e"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#eae7ea"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#ecedeb"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#202020",
    fillOpacity: 0.906
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#d2d1d2"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#686962"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#492521"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#b58b4e"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#cec685"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#aeaca2"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#d3d3d4"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#f0f1f2"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#f1f3f0"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.267
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#7e807d"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#3d2628"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#89552d"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#e4cd80"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#acaa8d"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1z",
    fill: "#c3c2c4"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#ebe7ec"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#212121",
    fillOpacity: 0.906
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#fdfdfe"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#fffffe"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#c6c2c5"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#5f5447"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#99937a"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#b1b2aa"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#d4d3d1"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#eff0ee"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#333",
    fillOpacity: 0.694
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#dcdbdc"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#71615a"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#827959"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#b0ac9e"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#c3c3c4"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h-1v-1h1z",
    fill: "#e9e7e6"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#202020",
    fillOpacity: 0.902
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#d3d5d3"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#595555"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#adadac"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#d4d4d1"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#f0f0ee"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#353535",
    fillOpacity: 0.694
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#f1efee"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#f7f8fa"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#696764"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#908d8c"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#e9e8e4"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#212121",
    fillOpacity: 0.902
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#b9b9b9",
    fillOpacity: 0.275
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#616161",
    fillOpacity: 0.082
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#212121",
    fillOpacity: 0.898
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.278
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#363636",
    fillOpacity: 0.694
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#202020",
    fillOpacity: 0.89
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#353535",
    fillOpacity: 0.678
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#696968"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#656566"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#1f1f20"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#d0d4d1"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#8f8e8f"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#d7d7d5"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#343434",
    fillOpacity: 0.671
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#848585"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#d1d3d2"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#656568"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#c7c7c5"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#080708"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#090608"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#b2b1ae"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#cdcecd"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#605f52"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#ada9a2"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#d3d3d1"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#6c6b6d"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#838580"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#7f7e78"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#c9c7c0"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#f4f2f4"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#bcbbbc"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#474847"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#230e12"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#623032"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#673728"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#b9a969"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#bfbb9b"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#d1d1d2"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#eeeff0"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#08090a"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#060001"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#4d2a2f"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#633733"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#866b42"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#c7c191"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#c3c3ba"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#e8e7ea"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#f3f1f2"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#f6f7f7"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#abaaad"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#553d40"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#97393c"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#d15b37"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#f5ca64"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#c3be89"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#d1d1d3"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#343434",
    fillOpacity: 0.663
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#bdbebf"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#544f4f"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#712e31"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#be4539"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#eba44d"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#d9cc7a"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#c1c3b8"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#e6e7e9"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#f2f1f1"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#bababa",
    fillOpacity: 0.671
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#bcb5b2"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#892f33"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1z",
    fill: "#dd5331"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#f6bf51"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1z",
    fill: "#c8c183"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#cfd0ce"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#f0f1f1"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#b5b5b5",
    fillOpacity: 0.286
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#edefee"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#70423f"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#cc4139"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#ec943a"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#e0cd70"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#c1c2b5"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#e7e7e6"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#bababa",
    fillOpacity: 0.675
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#222",
    fillOpacity: 0.878
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#e2e2e3"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#c4bdbc"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#893234"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#da4c31"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#f3b64f"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#d0c883"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#d2d1cc"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#edeeed"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#f0f0f2"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#b6b6b6",
    fillOpacity: 0.29
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#754a49"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#cb3e38"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#e68739"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#e7d16f"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#c6c4b1"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#e6e7e6"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#f3f1f3"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1z",
    fill: "#bbb",
    fillOpacity: 0.671
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#4c4c4e"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#5c5555"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#8c3237"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#dc4936"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#efab49"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#d9ce7e"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#d3cfc7"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79v1h-1v-1z",
    fill: "#f0eeee"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#5a5a59"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#696a6b"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#693b3a"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#d0403d"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#e47b35"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#edd36c"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#c9c6ab"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#e6e6e5"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#d0d0d2"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#292321"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1z",
    fill: "#8c3036"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#de4438"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#ec9d43"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#e2d377"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#d4d0c3"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#eeedef"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#eeefee"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#4c4d4c"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#491616"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#d74344"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#e16c32"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#f1d364"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#cdc9a3"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#e7e7e4"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#aaa4a0"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#8a3035"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#df4138"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#ea8f3c"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#ebd873"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#d6d3c0"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#edeeee"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#e4e3e4"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.302
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#dddfdd"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#6b3939"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#d33f44"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#e1612f"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#f4d35f"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#d4cfa1"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#e7e6e3"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#c8c9c6"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#dfdedd"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#762f31"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#dd3e3c"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#e87c36"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#f0db6c"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#d6d7b9"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#b7b7b7",
    fillOpacity: 0.306
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#343434",
    fillOpacity: 0.647
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#0a090a"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#919192"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#7f5b5b"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#bf363a"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#e3542f"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1z",
    fill: "#f3cc57"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#d7d599"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#e6e7e1"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M86 82v1h-1v-1z",
    fill: "#f2f1f2"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#ebeaeb"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#242424",
    fillOpacity: 0.875
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#b2b1b1"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#eaeeed"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#743738"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#d73c3c"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#e26f31"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#f2d965"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#d9d9b3"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#ebedee"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.31
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#686768"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#8a706f"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#b23133"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#e14c2f"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#f3c34c"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#dcd993"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h-1v-1h1z",
    fill: "#e4e6e1"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1z",
    fill: "#f0f1ef"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.878
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#e8eae8"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#773838"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#d93d3e"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#df612f"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#f5d35c"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#dfddad"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.318
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#f8f7f7"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#8c7373"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#b33232"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#e24633"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#f1b449"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#e5dd8d"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1z",
    fill: "#e5e6e3"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1z",
    fill: "#f0f1f3"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#b8b8b8",
    fillOpacity: 0.663
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#d2ccca"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#7b2e2f"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#e14041"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#dc542e"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#f4c952"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#e6e0a6"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#efecee"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#efefed"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#b5b8b8",
    fillOpacity: 0.325
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#7c5759"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#c13737"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#e14135"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#eba03f"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1z",
    fill: "#ede080"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#e8e8da"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#555655"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#707170"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#453838"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#973839"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#e94041"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#db4b2e"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#f1bd4d"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#e9e492"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#eeece8"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#c9cac9"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.333
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#7d7e7d"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#6e6e6c"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#642a2c"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#db4445"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#e03e37"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#e5903b"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h-1v-1h1z",
    fill: "#f1e470"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#e9e8cf"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#f1eff1"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v-1h1v1z",
    fill: "#bababa",
    fillOpacity: 0.655
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#262626",
    fillOpacity: 0.875
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#5d5d5c"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#160a0a"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#933435"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#ea4043"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#dd4330"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#eeab45"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#ede687"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#eeeee0"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#c9c8c8"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#b7b7b7",
    fillOpacity: 0.337
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#111110"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#551c1d"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#df4647"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#e43b37"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#e07e34"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#f3e169"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1z",
    fill: "#eaebc7"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#eef1f3"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#aba6a4"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#84302e"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#e54244"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#e13e35"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#eb973e"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#f3e77a"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#eff1d7"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#e3e4e3"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#cac8c9"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#b5b5b5",
    fillOpacity: 0.341
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.655
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#cfd2d0"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#6a3b3a"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#d0403f"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#f7db5f"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#eeeeba"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M86 89h-1v-1h1z",
    fill: "#edf0f3"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#252525",
    fillOpacity: 0.871
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#d1cecd"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#853332"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#e44143"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#e33c3a"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#e28132"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#f4e36c"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#f1efce"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#f1eef1"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#cacbcb"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#b7b7b7",
    fillOpacity: 0.349
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#7d5150"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1z",
    fill: "#cc3d3d"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#eb3b3d"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#db5a2e"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#f4ce52"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#f2edac"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v-1h1v1z",
    fill: "#e9e9ea"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#242424",
    fillOpacity: 0.867
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#0a0b0a"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#535454"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#979392"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#7a2d2f"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#e34144"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#f3dd5b"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#f3edbf"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#e3e3e1"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#cacbcc"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#b4b4b4",
    fillOpacity: 0.361
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#373737",
    fillOpacity: 0.643
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#adafaf"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#6f4948"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#c93a3c"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#ec3e3f"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#dc4d2e"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#efc04c"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#f0ec98"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#f3eee6"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#777",
    fillOpacity: 0.059
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#252525",
    fillOpacity: 0.859
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#2d2e2d"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#050403"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#5b191b"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#df4447"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#ea3d3f"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#db5930"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#f3d254"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#f3eeab"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#efefe9"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#e2e3e3"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#b4b4b2",
    fillOpacity: 0.365
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#07090a"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#2c0d0c"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#c33e3f"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#df4432"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#ecad42"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#f2ec86"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#f3efe0"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1z",
    fill: "#e8e8e9"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#7f7f7f",
    fillOpacity: 0.055
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#252525",
    fillOpacity: 0.851
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#828485"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#481516"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#d54445"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#ec3c41"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#dd4a33"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#f3c14c"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#f4ed91"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#eeefe4"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#e2e2e4"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#b4b4b1",
    fillOpacity: 0.376
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#a5a6a8"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#321d1e"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#ad3938"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#e43c37"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#e9963c"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#f5e973"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#f2efd3"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#252525",
    fillOpacity: 0.843
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#ccd1d2"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#3d1817"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#cb4141"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#eb3b40"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#df4235"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#eeac42"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#f6eb7f"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#efefde"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#cccccd"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.388
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#393939",
    fillOpacity: 0.647
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#4e4142"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1z",
    fill: "#99322e"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#eb4041"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#e47f39"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#f6e465"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#f3efc4"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#272727",
    fillOpacity: 0.843
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#bebebe"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#2c2d2d"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#929291"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#b7b7b8"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#2e1616"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#be3e3f"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#ee3d41"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#e03e32"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#e99435"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#f7e86b"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#f0eece"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#e1e4e2"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#b3b5b8",
    fillOpacity: 0.396
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#393939",
    fillOpacity: 0.631
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#7c7c7b"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#d9d9da"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1z",
    fill: "#4b4244"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h1v1h-1z",
    fill: "#842b2b"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#e94243"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#df692e"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#f8db55"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#f3edae"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#e7e9e5"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#d8d8dc"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#b8baba",
    fillOpacity: 0.667
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#282828",
    fillOpacity: 0.835
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#c1c1c1"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#8b8c8c"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#414140"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#1b0809"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#b23a3c"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#ef3e40"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#e43d36"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#e37a30"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#f9e15c"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#f2eeba"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#e2e4e0"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#d4d5d6"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#b6b6b9",
    fillOpacity: 0.4
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#393939",
    fillOpacity: 0.624
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#7c7d7d"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#555659"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#1b1717"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#762828"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#e94343"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-1v-1h1z",
    fill: "#dd562c"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#f6cd46"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1z",
    fill: "#f6ec99"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#e8eadf"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#b8babb",
    fillOpacity: 0.667
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#292929",
    fillOpacity: 0.839
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#575758"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#b7bab9"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#140808"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#9a3134"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#ed4040"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#e93d3d"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#de5f30"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#f8d550"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#f2eca1"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#e5e3de"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#b4b4b4",
    fillOpacity: 0.404
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#e3e5e4"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#e5e6e9"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#2f2e2f"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#5c1a19"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#e44444"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M83 97h-1v-1h1z",
    fill: "#eb3d3e"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M83 96h1v1h-1z",
    fill: "#de4630"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1z",
    fill: "#f2b53e"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1z",
    fill: "#f8ea83"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1z",
    fill: "#ebead4"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v-1h1v1z",
    fill: "#b8b8bb",
    fillOpacity: 0.667
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1z",
    fill: "#9c9c9c",
    fillOpacity: 0.051
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.843
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#504f50"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#ccd0ce"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#100a0a"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#82292b"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#ea4244"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#eb3e3e"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#dd4e30"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#f2c548"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#f1ea8e"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#e7e3db"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#d4d4d6"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#cdcbcf"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#b4b4b2",
    fillOpacity: 0.404
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#dcdedd"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98h-1v-1h1z",
    fill: "#3e4142"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#450f0f"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#dc4348"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#e23e30"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#e99c3f"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1z",
    fill: "#f7e871"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#eceac9"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#b7b7ba",
    fillOpacity: 0.671
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#9b9a9a"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#cdcfcc"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#0d0a09"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#681e20"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#e54447"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#e73d3e"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#e04235"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#ecab41"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#f4e977"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#e7e5cf"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#d4d5d5"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#cccccf"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#b4b4b7",
    fillOpacity: 0.404
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#dddfde"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#fdfcfb"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#3e403e"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#300607"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98h1v1h-1z",
    fill: "#cf4146"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98h1v1h-1z",
    fill: "#e83f40"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98h1v1h-1z",
    fill: "#e33b37"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M85 98v1h-1v-1z",
    fill: "#e18036"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h-1v-1h1z",
    fill: "#f6e464"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#ece9ba"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#d5d3d9"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#bababb",
    fillOpacity: 0.671
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#cfd0cc"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#0d0b0a"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#501415"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#dd4445"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#e23d39"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#e48e38"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#f7e564"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#e7e5b9"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#d5d5d2"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#cececd"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#f7f9f9"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#fafaf9"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#414240"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#1d0000"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100h-1v-1h1z",
    fill: "#be3e3e"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#ed4142"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#e83b3f"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h1v1h-1z",
    fill: "#db652b"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#f8d855"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v1h-1z",
    fill: "#edea9c"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#dad9d4"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#d5d4d4"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M90 100h-1v-1h1z",
    fill: "#bababc",
    fillOpacity: 0.675
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#282828",
    fillOpacity: 0.839
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#cdd0cc"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#0c0b0c"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#360c0d"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#d04545"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#eb3f3e"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#e53c3b"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#db6e30"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#f8da5a"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#e9e5a2"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#d7d5d2"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#cecdcf"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#393939",
    fillOpacity: 0.643
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#fdfefe"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#0d0000"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#a43938"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1z",
    fill: "#ea4342"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101h-1v-1h1z",
    fill: "#e93d41"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101h-1v-1h1z",
    fill: "#d8502c"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#f4c148"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#efe787"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#dbd8d0"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#d4d5d1"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M89 100h1v1h-1z",
    fill: "#bababa",
    fillOpacity: 0.667
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#919191",
    fillOpacity: 0.055
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.851
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#d0d3cf"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#0d0c0e"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#1f0505"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#be4043"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#eb4040"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#e93b3d"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#db552b"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#f5c94e"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#ebe58b"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#d8d6ca"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#b4b6b6",
    fillOpacity: 0.4
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#3e3e3e",
    fillOpacity: 0.659
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1z",
    fill: "#fefefc"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#424141"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#8a3033"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#e94345"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v-1h1v1z",
    fill: "#dd4333"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101v1h-1v-1z",
    fill: "#eda640"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#f3e774"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M88 102h-1v-1h1z",
    fill: "#dcdbc1"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#d3d5d7"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v1h-1v-1z",
    fill: "#b8baba",
    fillOpacity: 0.671
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#8d8d8d",
    fillOpacity: 0.071
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#2c2c2c",
    fillOpacity: 0.875
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#898988"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#b9b8b7"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#0e1010"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#0f0101"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#a7393e"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#ed3f42"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#df442d"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#efb042"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#f0e571"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#d9d8c0"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#cccecc"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#b6b1b6",
    fillOpacity: 0.4
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#3f3f3f",
    fillOpacity: 0.667
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#d8d8d6"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#6f262b"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1z",
    fill: "#e94348"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#e33c35"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1z",
    fill: "#e68638"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M87 103h-1v-1h1z",
    fill: "#f5e45f"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h1v1h-1z",
    fill: "#dedda9"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103v-1h1v1z",
    fill: "#d1d5d8"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103h-1v-1h1z",
    fill: "#bcb9c0",
    fillOpacity: 0.675
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#8c8c8c",
    fillOpacity: 0.078
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.886
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#1e1b1c"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#050807"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#080000"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#8b2e31"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#ec4143"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#e83e3e"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#e33d35"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#e59238"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#f4e363"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#dad9b2"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#cacece"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#b5b3b8",
    fillOpacity: 0.396
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#3d3d3d",
    fillOpacity: 0.651
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#1f1e1d"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#161717"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#54191e"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#e14348"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#ea3d3e"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M85 104h-1v-1h1z",
    fill: "#e73b39"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#de6a2f"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104h-1v-1h1z",
    fill: "#f7da55"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v-1h1v1z",
    fill: "#e1dd99"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#d3d6d5"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#bbb9c0",
    fillOpacity: 0.686
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#939393",
    fillOpacity: 0.075
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#2c2c2c",
    fillOpacity: 0.882
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#010100"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#000100"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#682223"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#e44543"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#ea3e3c"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#e53c39"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#dc6e2f"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#f8da5d"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#e0dd9b"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#cccfca"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#b5b2ba",
    fillOpacity: 0.392
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#370e10"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#d04345"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#ec3d3e"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105h-1v-1h1z",
    fill: "#ea3b3c"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#d9522b"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#f6c34a"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105h-1v-1h1z",
    fill: "#e9e188"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#d7d7ca"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105h-1v-1h1z",
    fill: "#bbb8bf",
    fillOpacity: 0.706
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1z",
    fill: "#a3a3a3",
    fillOpacity: 0.055
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#2c2c2c",
    fillOpacity: 0.863
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#000103"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#000102"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#461618"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#db4543"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#ec3e3b"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#ea3e3d"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#dc522e"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#f5c74e"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h1z",
    fill: "#e8e185"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#cfcfc2"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#b6b3bc",
    fillOpacity: 0.345
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#373737",
    fillOpacity: 0.592
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#000101"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#1d0606"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#bc3f40"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#ec3f3d"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#ec3c40"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#dd4231"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v1h-1z",
    fill: "#eca43d"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#eee473"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#dcd9ba"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v1h-1v-1z",
    fill: "#b8b9be",
    fillOpacity: 0.694
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#292929",
    fillOpacity: 0.722
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#2d0b0b"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#c84340"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#ee3f3d"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#ee3c41"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#e34031"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#f0ac40"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#f2e77d"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#cac6b1",
    fillOpacity: 0.925
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#b1b1bf",
    fillOpacity: 0.141
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#323232",
    fillOpacity: 0.42
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#000202"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106v1h-1v-1z",
    fill: "#0c0101"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107v-1h1v1z",
    fill: "#9f3736"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#ee4141"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#eb3e43"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#e53b37"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M87 106v1h-1v-1z",
    fill: "#e48230"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1z",
    fill: "#f3e563"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#dddcae"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106v1h-1v-1z",
    fill: "#b8b8c0",
    fillOpacity: 0.498
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h-1v-1h1z",
    fill: "#323232",
    fillOpacity: 0.2
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#353535",
    fillOpacity: 0.741
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#404040",
    fillOpacity: 0.961
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#170203"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#b33e3e"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#f04343"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#e0423c"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#dc8f49"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#e3d584",
    fillOpacity: 0.847
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#c4c1a2",
    fillOpacity: 0.325
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#2e2e2e",
    fillOpacity: 0.667
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#414141",
    fillOpacity: 0.961
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#000201"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#010000"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#7e2a2b"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#ee4646"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107h1v1h-1z",
    fill: "#ed4041"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#e93f3e"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#dc6c39"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1z",
    fill: "#edd272",
    fillOpacity: 0.965
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h-1v-1h1z",
    fill: "#cdca9b",
    fillOpacity: 0.631
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h-1v-1h1z",
    fill: "#bfb2cc",
    fillOpacity: 0.078
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v1h-1v-1z",
    fill: "#444",
    fillOpacity: 0.176
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108h1v1h-1z",
    fill: "#272727",
    fillOpacity: 0.376
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#0c0c0c",
    fillOpacity: 0.565
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#050505",
    fillOpacity: 0.706
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#050505",
    fillOpacity: 0.8
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#030303",
    fillOpacity: 0.867
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#020202",
    fillOpacity: 0.906
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.937
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#020202",
    fillOpacity: 0.945
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.949
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#030303",
    fillOpacity: 0.945
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#020404",
    fillOpacity: 0.922
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#0c0504",
    fillOpacity: 0.886
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#8a3a3a",
    fillOpacity: 0.804
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#ca5051",
    fillOpacity: 0.737
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#c14f4d",
    fillOpacity: 0.655
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#bb5551",
    fillOpacity: 0.502
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#b67a59",
    fillOpacity: 0.302
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#b2a57f",
    fillOpacity: 0.078
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M68 108v1h-1v-1z",
    fill: "#313131",
    fillOpacity: 0.408
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#050505",
    fillOpacity: 0.745
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#040404",
    fillOpacity: 0.831
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.886
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#020202",
    fillOpacity: 0.957
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#020202",
    fillOpacity: 0.969
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108v1h-1v-1z",
    fill: "#020202",
    fillOpacity: 0.992
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#020302"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#030303",
    fillOpacity: 0.996
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#030202",
    fillOpacity: 0.957
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M82 109v-1h1v1z",
    fill: "#592324",
    fillOpacity: 0.898
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108h1v1h-1z",
    fill: "#ca5050",
    fillOpacity: 0.831
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v1h-1v-1z",
    fill: "#c94b49",
    fillOpacity: 0.765
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#c04f4c",
    fillOpacity: 0.651
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#b9664e",
    fillOpacity: 0.459
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#caa878",
    fillOpacity: 0.208
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.02
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.063
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#151515",
    fillOpacity: 0.094
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#111",
    fillOpacity: 0.114
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#151515",
    fillOpacity: 0.137
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#141414",
    fillOpacity: 0.149
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#131313",
    fillOpacity: 0.157
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#1b1b1b",
    fillOpacity: 0.145
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#232323",
    fillOpacity: 0.114
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.024
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#383838",
    fillOpacity: 0.035
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#191919",
    fillOpacity: 0.078
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#101010",
    fillOpacity: 0.122
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#0c0c0c",
    fillOpacity: 0.165
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#0f0f0f",
    fillOpacity: 0.188
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#0d0d0d",
    fillOpacity: 0.216
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#101010",
    fillOpacity: 0.239
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#131313",
    fillOpacity: 0.259
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.267
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#171717",
    fillOpacity: 0.255
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#171717",
    fillOpacity: 0.212
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.165
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#4a3535",
    fillOpacity: 0.094
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M84 109v1h-1v-1z",
    fill: "#997f7f",
    fillOpacity: 0.039
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1z",
    fill: "#0ff",
    fillOpacity: 0.008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkalineBatteries);
export default __webpack_public_path__ + "static/media/alkaline-batteries.4eb70e95141b3564bded3551b6a68b7a.svg";
export { ForwardRef as ReactComponent };